import produce from 'immer';
import {
  createElement,
  Fragment,
  createRef,
  useEffect,
  isValidElement,
  useState,
  PureComponent,
  Component
} from 'react';
import { unmountComponentAtNode, render } from 'react-dom';
import * as $ from 'jquery';
import { connect, Provider } from 'react-redux';
import { createSelector } from 'reselect';
import classNames from 'classnames';
import { createStore, applyMiddleware, compose } from 'redux';
import thunk$1 from 'redux-thunk';

var fails = function(exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var toString = {}.toString;

var classofRaw = function(it) {
  return toString.call(it).slice(8, -1);
};

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails(function() {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins
  return !Object('z').propertyIsEnumerable(0);
})
  ? function(it) {
      return classofRaw(it) == 'String' ? split.call(it, '') : Object(it);
    }
  : Object;

// `RequireObjectCoercible` abstract operation
// https://tc39.github.io/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible = function(it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings

var toIndexedObject = function(it) {
  return indexedObject(requireObjectCoercible(it));
};

var commonjsGlobal =
  typeof globalThis !== 'undefined'
    ? globalThis
    : typeof window !== 'undefined'
    ? window
    : typeof global !== 'undefined'
    ? global
    : typeof self !== 'undefined'
    ? self
    : {};

function createCommonjsModule(fn, module) {
  return (module = { exports: {} }), fn(module, module.exports), module.exports;
}

var check = function(it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global_1 =
  // eslint-disable-next-line no-undef
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func
  Function('return this')();

// Thank's IE8 for his funny defineProperty
var descriptors = !fails(function() {
  return (
    Object.defineProperty({}, 'a', {
      get: function() {
        return 7;
      }
    }).a != 7
  );
});

var isObject = function(it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

var document = global_1.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

var documentCreateElement = function(it) {
  return EXISTS ? document.createElement(it) : {};
};

// Thank's IE8 for his funny defineProperty
var ie8DomDefine =
  !descriptors &&
  !fails(function() {
    return (
      Object.defineProperty(documentCreateElement('div'), 'a', {
        get: function() {
          return 7;
        }
      }).a != 7
    );
  });

var anObject = function(it) {
  if (!isObject(it)) {
    throw TypeError(String(it) + ' is not an object');
  }
  return it;
};

// `ToPrimitive` abstract operation
// https://tc39.github.io/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
var toPrimitive = function(input, PREFERRED_STRING) {
  if (!isObject(input)) return input;
  var fn, val;
  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject((val = fn.call(input)))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject((val = fn.call(input)))) return val;
  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject((val = fn.call(input)))) return val;
  throw TypeError("Can't convert object to primitive value");
};

var nativeDefineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.github.io/ecma262/#sec-object.defineproperty
var f = descriptors
  ? nativeDefineProperty
  : function defineProperty(O, P, Attributes) {
      anObject(O);
      P = toPrimitive(P, true);
      anObject(Attributes);
      if (ie8DomDefine)
        try {
          return nativeDefineProperty(O, P, Attributes);
        } catch (error) {
          /* empty */
        }
      if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
      if ('value' in Attributes) O[P] = Attributes.value;
      return O;
    };

var objectDefineProperty = {
  f: f
};

var createPropertyDescriptor = function(bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var createNonEnumerableProperty = descriptors
  ? function(object, key, value) {
      return objectDefineProperty.f(object, key, createPropertyDescriptor(1, value));
    }
  : function(object, key, value) {
      object[key] = value;
      return object;
    };

var setGlobal = function(key, value) {
  try {
    createNonEnumerableProperty(global_1, key, value);
  } catch (error) {
    global_1[key] = value;
  }
  return value;
};

var SHARED = '__core-js_shared__';
var store = global_1[SHARED] || setGlobal(SHARED, {});

var sharedStore = store;

var shared = createCommonjsModule(function(module) {
  (module.exports = function(key, value) {
    return sharedStore[key] || (sharedStore[key] = value !== undefined ? value : {});
  })('versions', []).push({
    version: '3.4.8',
    mode: 'global',
    copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
  });
});

var hasOwnProperty = {}.hasOwnProperty;

var has = function(it, key) {
  return hasOwnProperty.call(it, key);
};

var id = 0;
var postfix = Math.random();

var uid = function(key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};

var nativeSymbol =
  !!Object.getOwnPropertySymbols &&
  !fails(function() {
    // Chrome 38 Symbol has incorrect toString conversion
    // eslint-disable-next-line no-undef
    return !String(Symbol());
  });

var useSymbolAsUid =
  nativeSymbol &&
  // eslint-disable-next-line no-undef
  !Symbol.sham &&
  // eslint-disable-next-line no-undef
  typeof Symbol() == 'symbol';

var WellKnownSymbolsStore = shared('wks');
var Symbol$1 = global_1.Symbol;
var createWellKnownSymbol = useSymbolAsUid ? Symbol$1 : uid;

var wellKnownSymbol = function(name) {
  if (!has(WellKnownSymbolsStore, name)) {
    if (nativeSymbol && has(Symbol$1, name)) WellKnownSymbolsStore[name] = Symbol$1[name];
    else WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
  }
  return WellKnownSymbolsStore[name];
};

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.github.io/ecma262/#sec-tointeger
var toInteger = function(argument) {
  return isNaN((argument = +argument)) ? 0 : (argument > 0 ? floor : ceil)(argument);
};

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.github.io/ecma262/#sec-tolength
var toLength = function(argument) {
  return argument > 0 ? min(toInteger(argument), 0x1fffffffffffff) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var max = Math.max;
var min$1 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex = function(index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min$1(integer, length);
};

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function(IS_INCLUDES) {
  return function($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el)
      while (length > index) {
        value = O[index++];
        // eslint-disable-next-line no-self-compare
        if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
      }
    else
      for (; length > index; index++) {
        if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
      }
    return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};

var hiddenKeys = {};

var indexOf = arrayIncludes.indexOf;

var objectKeysInternal = function(object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i)
    if (has(O, (key = names[i++]))) {
      ~indexOf(result, key) || result.push(key);
    }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

// `Object.keys` method
// https://tc39.github.io/ecma262/#sec-object.keys
var objectKeys =
  Object.keys ||
  function keys(O) {
    return objectKeysInternal(O, enumBugKeys);
  };

// `Object.defineProperties` method
// https://tc39.github.io/ecma262/#sec-object.defineproperties
var objectDefineProperties = descriptors
  ? Object.defineProperties
  : function defineProperties(O, Properties) {
      anObject(O);
      var keys = objectKeys(Properties);
      var length = keys.length;
      var index = 0;
      var key;
      while (length > index) objectDefineProperty.f(O, (key = keys[index++]), Properties[key]);
      return O;
    };

var path = global_1;

var aFunction = function(variable) {
  return typeof variable == 'function' ? variable : undefined;
};

var getBuiltIn = function(namespace, method) {
  return arguments.length < 2
    ? aFunction(path[namespace]) || aFunction(global_1[namespace])
    : (path[namespace] && path[namespace][method]) || (global_1[namespace] && global_1[namespace][method]);
};

var html = getBuiltIn('document', 'documentElement');

var keys = shared('keys');

var sharedKey = function(key) {
  return keys[key] || (keys[key] = uid(key));
};

var IE_PROTO = sharedKey('IE_PROTO');

var PROTOTYPE = 'prototype';
var Empty = function() {
  /* empty */
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function() {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var length = enumBugKeys.length;
  var lt = '<';
  var script = 'script';
  var gt = '>';
  var js = 'java' + script + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  iframe.src = String(js);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + script + gt + 'document.F=Object' + lt + '/' + script + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (length--) delete createDict[PROTOTYPE][enumBugKeys[length]];
  return createDict();
};

// `Object.create` method
// https://tc39.github.io/ecma262/#sec-object.create
var objectCreate =
  Object.create ||
  function create(O, Properties) {
    var result;
    if (O !== null) {
      Empty[PROTOTYPE] = anObject(O);
      result = new Empty();
      Empty[PROTOTYPE] = null;
      // add "__proto__" for Object.getPrototypeOf polyfill
      result[IE_PROTO] = O;
    } else result = createDict();
    return Properties === undefined ? result : objectDefineProperties(result, Properties);
  };

hiddenKeys[IE_PROTO] = true;

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  createNonEnumerableProperty(ArrayPrototype, UNSCOPABLES, objectCreate(null));
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables = function(key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};

var functionToString = Function.toString;

// this helper broken in `3.4.1-3.4.4`, so we can't use `shared` helper
if (typeof sharedStore.inspectSource != 'function') {
  sharedStore.inspectSource = function(it) {
    return functionToString.call(it);
  };
}

var inspectSource = sharedStore.inspectSource;

var WeakMap = global_1.WeakMap;

var nativeWeakMap = typeof WeakMap === 'function' && /native code/.test(inspectSource(WeakMap));

var WeakMap$1 = global_1.WeakMap;
var set, get, has$1;

var enforce = function(it) {
  return has$1(it) ? get(it) : set(it, {});
};

var getterFor = function(TYPE) {
  return function(it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    }
    return state;
  };
};

if (nativeWeakMap) {
  var store$1 = new WeakMap$1();
  var wmget = store$1.get;
  var wmhas = store$1.has;
  var wmset = store$1.set;
  set = function(it, metadata) {
    wmset.call(store$1, it, metadata);
    return metadata;
  };
  get = function(it) {
    return wmget.call(store$1, it) || {};
  };
  has$1 = function(it) {
    return wmhas.call(store$1, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function(it, metadata) {
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function(it) {
    return has(it, STATE) ? it[STATE] : {};
  };
  has$1 = function(it) {
    return has(it, STATE);
  };
}

var internalState = {
  set: set,
  get: get,
  has: has$1,
  enforce: enforce,
  getterFor: getterFor
};

var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !nativePropertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.propertyisenumerable
var f$1 = NASHORN_BUG
  ? function propertyIsEnumerable(V) {
      var descriptor = getOwnPropertyDescriptor(this, V);
      return !!descriptor && descriptor.enumerable;
    }
  : nativePropertyIsEnumerable;

var objectPropertyIsEnumerable = {
  f: f$1
};

var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptor
var f$2 = descriptors
  ? nativeGetOwnPropertyDescriptor
  : function getOwnPropertyDescriptor(O, P) {
      O = toIndexedObject(O);
      P = toPrimitive(P, true);
      if (ie8DomDefine)
        try {
          return nativeGetOwnPropertyDescriptor(O, P);
        } catch (error) {
          /* empty */
        }
      if (has(O, P)) return createPropertyDescriptor(!objectPropertyIsEnumerable.f.call(O, P), O[P]);
    };

var objectGetOwnPropertyDescriptor = {
  f: f$2
};

var redefine = createCommonjsModule(function(module) {
  var getInternalState = internalState.get;
  var enforceInternalState = internalState.enforce;
  var TEMPLATE = String(String).split('String');

  (module.exports = function(O, key, value, options) {
    var unsafe = options ? !!options.unsafe : false;
    var simple = options ? !!options.enumerable : false;
    var noTargetGet = options ? !!options.noTargetGet : false;
    if (typeof value == 'function') {
      if (typeof key == 'string' && !has(value, 'name')) createNonEnumerableProperty(value, 'name', key);
      enforceInternalState(value).source = TEMPLATE.join(typeof key == 'string' ? key : '');
    }
    if (O === global_1) {
      if (simple) O[key] = value;
      else setGlobal(key, value);
      return;
    } else if (!unsafe) {
      delete O[key];
    } else if (!noTargetGet && O[key]) {
      simple = true;
    }
    if (simple) O[key] = value;
    else createNonEnumerableProperty(O, key, value);
    // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
  })(Function.prototype, 'toString', function toString() {
    return (typeof this == 'function' && getInternalState(this).source) || inspectSource(this);
  });
});

var hiddenKeys$1 = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertynames
var f$3 =
  Object.getOwnPropertyNames ||
  function getOwnPropertyNames(O) {
    return objectKeysInternal(O, hiddenKeys$1);
  };

var objectGetOwnPropertyNames = {
  f: f$3
};

var f$4 = Object.getOwnPropertySymbols;

var objectGetOwnPropertySymbols = {
  f: f$4
};

// all object keys, includes non-enumerable and symbols
var ownKeys =
  getBuiltIn('Reflect', 'ownKeys') ||
  function ownKeys(it) {
    var keys = objectGetOwnPropertyNames.f(anObject(it));
    var getOwnPropertySymbols = objectGetOwnPropertySymbols.f;
    return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
  };

var copyConstructorProperties = function(target, source) {
  var keys = ownKeys(source);
  var defineProperty = objectDefineProperty.f;
  var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};

var replacement = /#|\.prototype\./;

var isForced = function(feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL
    ? true
    : value == NATIVE
    ? false
    : typeof detection == 'function'
    ? fails(detection)
    : !!detection;
};

var normalize = (isForced.normalize = function(string) {
  return String(string)
    .replace(replacement, '.')
    .toLowerCase();
});

var data = (isForced.data = {});
var NATIVE = (isForced.NATIVE = 'N');
var POLYFILL = (isForced.POLYFILL = 'P');

var isForced_1 = isForced;

var getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
var _export = function(options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global_1;
  } else if (STATIC) {
    target = global_1[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global_1[TARGET] || {}).prototype;
  }
  if (target)
    for (key in source) {
      sourceProperty = source[key];
      if (options.noTargetGet) {
        descriptor = getOwnPropertyDescriptor$1(target, key);
        targetProperty = descriptor && descriptor.value;
      } else targetProperty = target[key];
      FORCED = isForced_1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
      // contained in target
      if (!FORCED && targetProperty !== undefined) {
        if (typeof sourceProperty === typeof targetProperty) continue;
        copyConstructorProperties(sourceProperty, targetProperty);
      }
      // add a flag to not completely full polyfills
      if (options.sham || (targetProperty && targetProperty.sham)) {
        createNonEnumerableProperty(sourceProperty, 'sham', true);
      }
      // extend global
      redefine(target, key, sourceProperty, options);
    }
};

// `ToObject` abstract operation
// https://tc39.github.io/ecma262/#sec-toobject
var toObject = function(argument) {
  return Object(requireObjectCoercible(argument));
};

var correctPrototypeGetter = !fails(function() {
  function F() {
    /* empty */
  }
  F.prototype.constructor = null;
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var IE_PROTO$1 = sharedKey('IE_PROTO');
var ObjectPrototype = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.getprototypeof
var objectGetPrototypeOf = correctPrototypeGetter
  ? Object.getPrototypeOf
  : function(O) {
      O = toObject(O);
      if (has(O, IE_PROTO$1)) return O[IE_PROTO$1];
      if (typeof O.constructor == 'function' && O instanceof O.constructor) {
        return O.constructor.prototype;
      }
      return O instanceof Object ? ObjectPrototype : null;
    };

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

var returnThis = function() {
  return this;
};

// `%IteratorPrototype%` object
// https://tc39.github.io/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = objectGetPrototypeOf(objectGetPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

if (IteratorPrototype == undefined) IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
if (!has(IteratorPrototype, ITERATOR)) {
  createNonEnumerableProperty(IteratorPrototype, ITERATOR, returnThis);
}

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};

var defineProperty = objectDefineProperty.f;

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

var setToStringTag = function(it, TAG, STATIC) {
  if (it && !has((it = STATIC ? it : it.prototype), TO_STRING_TAG)) {
    defineProperty(it, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};

var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;

var createIteratorConstructor = function(IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = objectCreate(IteratorPrototype$1, { next: createPropertyDescriptor(1, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false);
  return IteratorConstructor;
};

var aPossiblePrototype = function(it) {
  if (!isObject(it) && it !== null) {
    throw TypeError("Can't set " + String(it) + ' as a prototype');
  }
  return it;
};

// `Object.setPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var objectSetPrototypeOf =
  Object.setPrototypeOf ||
  ('__proto__' in {}
    ? (function() {
        var CORRECT_SETTER = false;
        var test = {};
        var setter;
        try {
          setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
          setter.call(test, []);
          CORRECT_SETTER = test instanceof Array;
        } catch (error) {
          /* empty */
        }
        return function setPrototypeOf(O, proto) {
          anObject(O);
          aPossiblePrototype(proto);
          if (CORRECT_SETTER) setter.call(O, proto);
          else O.__proto__ = proto;
          return O;
        };
      })()
    : undefined);

var IteratorPrototype$2 = iteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS$1 = iteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$1 = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis$1 = function() {
  return this;
};

var defineIterator = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function(KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS$1 && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS:
        return function keys() {
          return new IteratorConstructor(this, KIND);
        };
      case VALUES:
        return function values() {
          return new IteratorConstructor(this, KIND);
        };
      case ENTRIES:
        return function entries() {
          return new IteratorConstructor(this, KIND);
        };
    }
    return function() {
      return new IteratorConstructor(this);
    };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator =
    IterablePrototype[ITERATOR$1] || IterablePrototype['@@iterator'] || (DEFAULT && IterablePrototype[DEFAULT]);
  var defaultIterator = (!BUGGY_SAFARI_ITERATORS$1 && nativeIterator) || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = objectGetPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (IteratorPrototype$2 !== Object.prototype && CurrentIteratorPrototype.next) {
      if (objectGetPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype$2) {
        if (objectSetPrototypeOf) {
          objectSetPrototypeOf(CurrentIteratorPrototype, IteratorPrototype$2);
        } else if (typeof CurrentIteratorPrototype[ITERATOR$1] != 'function') {
          createNonEnumerableProperty(CurrentIteratorPrototype, ITERATOR$1, returnThis$1);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  }

  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    INCORRECT_VALUES_NAME = true;
    defaultIterator = function values() {
      return nativeIterator.call(this);
    };
  }

  // define iterator
  if (IterablePrototype[ITERATOR$1] !== defaultIterator) {
    createNonEnumerableProperty(IterablePrototype, ITERATOR$1, defaultIterator);
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED)
      for (KEY in methods) {
        if (BUGGY_SAFARI_ITERATORS$1 || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
          redefine(IterablePrototype, KEY, methods[KEY]);
        }
      }
    else _export({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS$1 || INCORRECT_VALUES_NAME }, methods);
  }

  return methods;
};

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = internalState.set;
var getInternalState = internalState.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.github.io/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.github.io/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.github.io/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.github.io/ecma262/#sec-createarrayiterator
var es_array_iterator = defineIterator(
  Array,
  'Array',
  function(iterated, kind) {
    setInternalState(this, {
      type: ARRAY_ITERATOR,
      target: toIndexedObject(iterated), // target
      index: 0, // next index
      kind: kind // kind
    });
    // `%ArrayIteratorPrototype%.next` method
    // https://tc39.github.io/ecma262/#sec-%arrayiteratorprototype%.next
  },
  function() {
    var state = getInternalState(this);
    var target = state.target;
    var kind = state.kind;
    var index = state.index++;
    if (!target || index >= target.length) {
      state.target = undefined;
      return { value: undefined, done: true };
    }
    if (kind == 'keys') return { value: index, done: false };
    if (kind == 'values') return { value: target[index], done: false };
    return { value: [index, target[index]], done: false };
  },
  'values'
);

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends =
    Object.assign ||
    function(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

  return _extends.apply(this, arguments);
}

function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly)
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$1(Object(source), true).forEach(function(key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$1(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

const has$2 = (a, b) => Boolean(a) && Object.prototype.hasOwnProperty.call(a, b); // IE10 Compat

/**
 * The isOf function is essentially indexOf.
 * @param {string[]} base is the list of values to check against
 * @param {string} value is the value being checked
 * @return {boolean} if element is found
 */

const isOf = (base, value) => base.includes(value);

const AVRO = {
  NUMBER: 'int',
  BOOL: 'boolean',
  NULL: 'null',
  DOUBLE: 'double',
  STRING: 'string',
  LONG: 'long'
};
const BBDS = {
  DEFAULT: 'com.bloomberg.Default',
  DATETIME: 'com.bloomberg.DateTime',
  DATE: 'com.bloomberg.Date',
  LEI: 'com.bloomberg.Lei',
  FIGI: 'com.bloomberg.Figi'
};
const TYPE = _objectSpread2({}, AVRO, {}, BBDS);

const ERROR_CODES = {
  INVAL_SCHEM: 'Unrecognized schema was given, store cannot be built.',
  INVAL_UNION: 'Union has no subtypes left.',
  INVAL_NESUN: 'Nested unions are not supported.',
  INVAL_COMPL: 'Union of records or enums without names is not supported.',
  INVAL_ARRAY: 'Arrays and maps cannot have either as children.',
  INVAL_TFIND: 'Cannot traverse schema if no root is defined.'
};

class AvroError extends Error {
  constructor(code) {
    super(ERROR_CODES[code]);
    this.code = code; // Remove class constructor from stack trace

    Error.captureStackTrace && Error.captureStackTrace(this, AvroError);
  }
}

AvroError.Codes = ERROR_CODES;
const helpers = {
  genChildren: function*(self, fieldType) {
    if (typeof fieldType === 'string') {
      if (!has$2(self.data, fieldType)) return;
      yield* helpers.genChildren(self, self.data[fieldType]);
    } else if (Array.isArray(fieldType))
      for (const subfieldType of fieldType)
        yield {
          step: self.constructor.getTypeName(subfieldType),
          type: subfieldType
        };
    else {
      switch (fieldType.type) {
        case 'record':
          // reverse to preserve order in stack
          for (let i = fieldType.fields.length; i > 0; ) {
            i--;
            const field = fieldType.fields[i];
            yield {
              step: field.name,
              type: field.type
            };
          }

          break;

        case 'string':
        case 'enum':
          break;

        case 'array':
          yield {
            step: null,
            type: fieldType.items
          };
          break;

        case 'map':
          yield {
            step: null,
            type: fieldType.values
          };
      }
    }
  },

  nextChildren(fieldType, path, next) {
    for (const { step, type: nextType } of helpers.genChildren(this, fieldType)) {
      next({
        fieldType: nextType,
        path: step ? [...path, step] : [...path]
      });
    }
  },

  genPathsForType: function*(self, type, root, offset) {
    const stack = [
      {
        fieldType: root || self.root,
        path: [...offset]
      }
    ];

    while (stack.length) {
      const { fieldType, path } = stack.pop();
      if (fieldType === type) yield path;
      helpers.nextChildren.call(self, fieldType, path, stack.push.bind(stack));
    }
  },

  unembedComplex(stack, elem) {
    if (typeof elem !== 'object' || !(elem.type === 'record' || elem.type === 'enum')) return elem;
    if (!elem.name) throw new AvroError('INVAL_COMPL');
    stack.push(elem);
    return elem.name;
  },

  filterFields(stack, field) {
    const { fieldType, isNullable } = this.constructor.getWithoutNull(field.type);
    const modifier = {
      nullable: isNullable
    };
    if (Array.isArray(fieldType)) modifier.type = fieldType.map(helpers.unembedComplex.bind(this, stack));
    else if (typeof fieldType === 'object') modifier.type = helpers.unembedComplex(stack, fieldType);
    else modifier.type = fieldType;
    return _objectSpread2({}, field, {}, modifier);
  },

  flatten(stack) {
    // $FlowFixMe
    const record = _objectSpread2({}, stack.pop());

    if (record.type === 'record') record.fields = record.fields.map(helpers.filterFields.bind(this, stack)); // copy record if aliases are present

    if (has$2(record, 'aliases') && record.aliases) {
      const aliases = record.aliases;
      delete record.aliases;
      aliases.forEach(name => {
        if (!Avro.ifAlias(name, this)) return; // $FlowFixMe

        this.data[name] = _objectSpread2({}, record, {
          name
        });
      });
    }

    this.data[record.name] = record;
  }
};

class Avro {
  constructor(schema, { useAlias = true, ignoreAlias = [], root = '' } = {}) {
    this.raw = schema;
    this.useAlias = useAlias;
    this.ignoreAlias = ignoreAlias;
    this.root = root;
    this.data = {};
    const stack = [...schema];

    while (stack.length) helpers.flatten.call(this, stack);
  }

  getPathsForType(type, root, offset) {
    if (!(root || this.root)) throw new AvroError('INVAL_TFIND');
    return [...helpers.genPathsForType(this, type, root, offset || [])];
  }

  static ifAlias(alias, { useAlias = true, ignoreAlias = [] }) {
    return (useAlias && !ignoreAlias.includes(alias)) || (!useAlias && ignoreAlias.includes(alias));
  }

  static getTypeName(fieldType) {
    if (typeof fieldType === 'string') return fieldType;
    if (Array.isArray(fieldType)) return 'union';
    if (fieldType && typeof fieldType === 'object')
      switch (fieldType.type) {
        case 'record':
        case 'enum':
          return fieldType.name;

        case 'string':
        case 'array':
        case 'map':
          return fieldType.type;
      }
    return undefined;
  }

  static getWithoutNull(fieldType) {
    let isKnownUnion = false,
      isNullable = false;
    if (!Array.isArray(fieldType))
      return {
        fieldType,
        isNullable
      };
    fieldType = [...fieldType];

    for (let i = fieldType.length - 1; i >= 0; i--) {
      const elem = fieldType[i];
      if (elem === AVRO.NULL) isNullable = true;
      else if (elem === BBDS.DEFAULT) isKnownUnion = true;
      else if (Array.isArray(elem)) throw new AvroError('INVAL_NESUN');
      // Lists, Maps, Emmbeded
      else continue;
      fieldType.splice(i, 1);
    }

    if (!fieldType.length) throw new AvroError('INVAL_UNION');
    if (fieldType.length < 2 && !isKnownUnion)
      return {
        fieldType: fieldType[0],
        isNullable
      };
    return {
      fieldType,
      isNullable
    };
  }
}

Avro.Error = AvroError;
Avro.Types = AVRO; // @ts-ignore

Avro._helpers = helpers;

var index = /*#__PURE__*/ Object.freeze({
  __proto__: null,
  Avro: Avro
});

var defineProperty$1 = objectDefineProperty.f;

var NativeSymbol = global_1.Symbol;

if (
  descriptors &&
  typeof NativeSymbol == 'function' &&
  (!('description' in NativeSymbol.prototype) ||
    // Safari 12 bug
    NativeSymbol().description !== undefined)
) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : String(arguments[0]);
    var result =
      this instanceof SymbolWrapper
        ? new NativeSymbol(description)
        : // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
        description === undefined
        ? NativeSymbol()
        : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };
  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  var symbolPrototype = (SymbolWrapper.prototype = NativeSymbol.prototype);
  symbolPrototype.constructor = SymbolWrapper;

  var symbolToString = symbolPrototype.toString;
  var native = String(NativeSymbol('test')) == 'Symbol(test)';
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  defineProperty$1(symbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = isObject(this) ? this.valueOf() : this;
      var string = symbolToString.call(symbol);
      if (has(EmptyStringDescriptionStore, symbol)) return '';
      var desc = native ? string.slice(7, -1) : string.replace(regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  _export(
    { global: true, forced: true },
    {
      Symbol: SymbolWrapper
    }
  );
}

// `RegExp.prototype.flags` getter implementation
// https://tc39.github.io/ecma262/#sec-get-regexp.prototype.flags
var regexpFlags = function() {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var UPDATES_LAST_INDEX_WRONG = (function() {
  var re1 = /a/;
  var re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      nativeReplace.call(match[0], reCopy, function() {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

var regexpExec = patchedExec;

var SPECIES = wellKnownSymbol('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function() {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function() {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function() {
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function() {
    return originalExec.apply(this, arguments);
  };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

var fixRegexpWellKnownSymbolLogic = function(KEY, length, exec, sham) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function() {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function() {
      return 7;
    };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC =
    DELEGATES_TO_SYMBOL &&
    !fails(function() {
      // Symbol-named RegExp methods call .exec
      var execCalled = false;
      var re = /a/;

      if (KEY === 'split') {
        // We can't use real regex here since it causes deoptimization
        // and serious performance degradation in V8
        // https://github.com/zloirock/core-js/issues/306
        re = {};
        // RegExp[@@split] doesn't call the regex's exec method, but first creates
        // a new one. We need to return the patched regex when creating the new one.
        re.constructor = {};
        re.constructor[SPECIES] = function() {
          return re;
        };
        re.flags = '';
        re[SYMBOL] = /./[SYMBOL];
      }

      re.exec = function() {
        execCalled = true;
        return null;
      };

      re[SYMBOL]('');
      return !execCalled;
    });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var methods = exec(SYMBOL, ''[KEY], function(nativeMethod, regexp, str, arg2, forceStringMethod) {
      if (regexp.exec === regexpExec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
        }
        return { done: true, value: nativeMethod.call(str, regexp, arg2) };
      }
      return { done: false };
    });
    var stringMethod = methods[0];
    var regexMethod = methods[1];

    redefine(String.prototype, KEY, stringMethod);
    redefine(
      RegExp.prototype,
      SYMBOL,
      length == 2
        ? // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
          // 21.2.5.11 RegExp.prototype[@@split](string, limit)
          function(string, arg) {
            return regexMethod.call(string, this, arg);
          }
        : // 21.2.5.6 RegExp.prototype[@@match](string)
          // 21.2.5.9 RegExp.prototype[@@search](string)
          function(string) {
            return regexMethod.call(string, this);
          }
    );
    if (sham) createNonEnumerableProperty(RegExp.prototype[SYMBOL], 'sham', true);
  }
};

// `String.prototype.{ codePointAt, at }` methods implementation
var createMethod$1 = function(CONVERT_TO_STRING) {
  return function($this, pos) {
    var S = String(requireObjectCoercible($this));
    var position = toInteger(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = S.charCodeAt(position);
    return first < 0xd800 ||
      first > 0xdbff ||
      position + 1 === size ||
      (second = S.charCodeAt(position + 1)) < 0xdc00 ||
      second > 0xdfff
      ? CONVERT_TO_STRING
        ? S.charAt(position)
        : first
      : CONVERT_TO_STRING
      ? S.slice(position, position + 2)
      : ((first - 0xd800) << 10) + (second - 0xdc00) + 0x10000;
  };
};

var stringMultibyte = {
  // `String.prototype.codePointAt` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod$1(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod$1(true)
};

var charAt = stringMultibyte.charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
var advanceStringIndex = function(S, index, unicode) {
  return index + (unicode ? charAt(S, index).length : 1);
};

// `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
var regexpExecAbstract = function(R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }

  if (classofRaw(R) !== 'RegExp') {
    throw TypeError('RegExp#exec called on incompatible receiver');
  }

  return regexpExec.call(R, S);
};

var max$1 = Math.max;
var min$2 = Math.min;
var floor$1 = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d\d?)/g;

var maybeToString = function(it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
fixRegexpWellKnownSymbolLogic('replace', 2, function(REPLACE, nativeReplace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible(this);
      var replacer = searchValue == undefined ? undefined : searchValue[REPLACE];
      return replacer !== undefined
        ? replacer.call(searchValue, O, replaceValue)
        : nativeReplace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function(regexp, replaceValue) {
      var res = maybeCallNative(nativeReplace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);

      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);

      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regexpExecAbstract(rx, S);
        if (result === null) break;

        results.push(result);
        if (!global) break;

        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = String(result[0]);
        var position = max$1(min$2(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

  // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return nativeReplace.call(replacement, symbols, function(match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$':
          return '$';
        case '&':
          return matched;
        case '`':
          return str.slice(0, position);
        case "'":
          return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default:
          // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor$1(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});

// a string of all valid unicode whitespaces
// eslint-disable-next-line max-len
var whitespaces =
  '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

var whitespace = '[' + whitespaces + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod$2 = function(TYPE) {
  return function($this) {
    var string = String(requireObjectCoercible($this));
    if (TYPE & 1) string = string.replace(ltrim, '');
    if (TYPE & 2) string = string.replace(rtrim, '');
    return string;
  };
};

var stringTrim = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.github.io/ecma262/#sec-string.prototype.trimstart
  start: createMethod$2(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.github.io/ecma262/#sec-string.prototype.trimend
  end: createMethod$2(2),
  // `String.prototype.trim` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.trim
  trim: createMethod$2(3)
};

var non = '\u200B\u0085\u180E';

// check that a method works with the correct list
// of whitespaces and has a correct name
var forcedStringTrimMethod = function(METHOD_NAME) {
  return fails(function() {
    return !!whitespaces[METHOD_NAME]() || non[METHOD_NAME]() != non || whitespaces[METHOD_NAME].name !== METHOD_NAME;
  });
};

var $trim = stringTrim.trim;

// `String.prototype.trim` method
// https://tc39.github.io/ecma262/#sec-string.prototype.trim
_export(
  { target: 'String', proto: true, forced: forcedStringTrimMethod('trim') },
  {
    trim: function trim() {
      return $trim(this);
    }
  }
);

const camelToLower = value =>
  value.replace(/(?:[a-z](?=[A-Z]))|(?:[A-Z](?=[A-Z][a-z]))|(?:[a-zA-Z](?=\d))/g, m => `${m} `);
const camelToTitle = value => camelToLower(value).replace(/^./, m => m.toUpperCase());
const camelToSnake = value => camelToLower(value).replace(/\s+/g, '_');
const camelToConst = value => camelToSnake(value).toUpperCase();
const constToCamel = value => value.toLowerCase().replace(/_\w/g, m => m[1].toUpperCase());

const DEFAULT_SEPARATOR = '|',
  BASE_ID = '0',
  ROOT = '$Root',
  PARENT = '$Parent',
  THIS = 'this';
const ERROR_CODES$1 = {
  ANCHOR_TERMINATOR: `This derive key seems to be missing the \`${ROOT}\` or \`${THIS}\` anchors.`,
  ANCHOR_ONLY: `This derive key seems to be missing the \`${ROOT}\` or \`${THIS}\` anchors.`,
  ROOT_VIOLATION: `Cannot derive \`${PARENT}\` key from an empty chain.`,
  PARENT_VIOLATION: `Cannot derive \`${PARENT}\` if derive starts with \`${ROOT}\`.`,
  TRESH_VIOLATION: 'Key derivation across List boundary is not supported.',
  REBASE_VIOLATION: 'Key is not related to key being rebased from.',
  RANGE_VIOLATION: 'Key is out of range.'
};

class ChainError extends Error {
  constructor(code) {
    super(ERROR_CODES$1[code]);
    this.code = code; // Remove class constructor from stack trace

    Error.captureStackTrace && Error.captureStackTrace(this, ChainError);
  }
}

ChainError.Codes = ERROR_CODES$1;
const helpers$1 = {
  unroot(value) {
    const chain = value.split('.').map(this.encode, this);
    if (!chain[0]) throw new ChainError('ANCHOR_TERMINATOR');
    else if (chain[chain.length - 1] === 'value') chain.pop();
    const root = chain[0];
    chain.splice(0, 1);
    if (root === ROOT && chain.some(x => x === PARENT)) throw new ChainError('PARENT_VIOLATION');
    else if (root !== ROOT && root !== THIS) throw new ChainError('ANCHOR_ONLY');
    return {
      root,
      target: chain
    };
  },

  /**
   * The _trace method creates an array of KeyChains as
   * each derive key was obeyed.
   * NOTE: This in an internal method.
   * @param {string[]} target is the split derive key.
   * @returns {KeyChain[]} history of chains created.
   */
  trace(target) {
    const history = [this.copy()];
    let moves = 1; // Traverse derive keys

    let thresh = -1;
    target.forEach(key => {
      // Rewind Chain if $Parent
      if (key === PARENT) {
        if (!history[moves - 1].length) throw new ChainError('ROOT_VIOLATION');
        else if (!isNaN(+history[moves - 1].peek())) thresh = 1;
        else if (thresh !== -1) thresh++;
        moves = history.push(history[moves - 1].pop());
        return;
      } else if (thresh !== -1) thresh--; // Throw if add key onto known List boundary

      if (!thresh && isNaN(+key)) throw new ChainError('TRESH_VIOLATION');
      // Add key otherwise
      else moves = history.push(history[moves - 1].push(key));
    });
    return history;
  },

  split(strval, head = true) {
    const arrval = strval.split('.');
    if (head) return arrval[arrval.length - 1];
    return arrval.slice(0, arrval.length - 1).join('.');
  }
};
/**
 * @class
 * The KeyChain helps keep node addressing consistent in the whole store.
 */

class KeyChain {
  constructor(value = [], { separator = DEFAULT_SEPARATOR } = {}) {
    this.separator = separator;
    this.chain = [];
    if (Array.isArray(value)) this.chain = value.map(this.encode, this);
    else if (typeof value === 'string') this.chain = this.split(value);
    else if (!isNaN(+value)) this.chain.push(this.encode(`${value}`));
  }

  get length() {
    return this.chain.length;
  }

  get key() {
    if (!this.length) throw new ChainError('RANGE_VIOLATION');
    return this.decode(this.chain[this.chain.length - 1]);
  }

  get keys() {
    return this.chain.map(this.decode, this);
  }

  get title() {
    return camelToTitle(helpers$1.split(this.key));
  }

  get namespace() {
    return helpers$1.split(this.key, false);
  }

  static escape(strval) {
    return strval.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }
  /**
   * Is derive key absolute or relative?
   * @param {string} value derive key
   */

  static isRelative(value) {
    return value.startsWith(`${ROOT}.`) || value.startsWith(`${THIS}.`);
  }
  /**
   * Determines if key contains unique keys
   * @param {string} value
   */

  static isUnique(value) {
    return value.length > new KeyChain(value).join(true).length;
  }
  /**
   * The setSeparator method will change the separator property of the chain.
   * @param {string?} separator is what the key will be joined by next
   * @return {KeyChain}
   */

  setSeparator(separator = DEFAULT_SEPARATOR) {
    this.separator = separator;
    return this;
  }
  /**
   * Will make target key base of this one.
   * @param {string | KeyChain} target is the key to rebase onto
   * @param {boolean?} forceAdd if one wants to force add (and remove first key)
   * @param {boolean?} safe safe return if not valid rebase
   * @returns {KeyChain}
   */

  rebase(target, { force = false, safe = false } = {}) {
    if (!(target instanceof KeyChain)) target = this.copy(target);
    const startsWith = this.startsWith(target);
    if (force || !this.length || (!startsWith && this.chain[0] === BASE_ID)) return target.concat(this.chain.slice(1));

    if (!startsWith) {
      if (!safe) throw new ChainError('REBASE_VIOLATION');
      return target;
    }

    const clippedCopy = this.chain.slice(target.length);
    /* istanbul ignore else */

    if (clippedCopy[0] !== BASE_ID) clippedCopy.unshift(BASE_ID);
    return this.copy(clippedCopy);
  }
  /**
   * Tests if key starts with another
   * @param {string | KeyChain} target is the key to check against
   * @returns {boolean}
   */

  startsWith(target) {
    /* istanbul ignore next */
    if (!(target instanceof KeyChain)) target = this.copy(target);
    return this.length >= target.length && !target.chain.some((v, i) => v !== this.chain[i]);
  }
  /**
   * The replace method will inject this key in a string.
   * @param {string} target is the string being replaced.
   * @param {string} pattern is the pattern in the string being replaced.
   * @return {string}
   */

  replace(target, pattern) {
    return target.replace(new RegExp(KeyChain.escape(pattern), 'g'), this.join());
  }

  startReplace(target, pattern, relative = false) {
    let result = target;
    if (Array.isArray(target))
      result = (target[0] === BASE_ID
        ? this.copy(target).rebase(this, {
            safe: true
          })
        : this.concat(target)
      ).keys;
    else if (pattern && target.startsWith(pattern)) result = this.replace(target, pattern);
    else if (relative && KeyChain.isRelative(target)) result = this.derive(target).join();
    /*:: result = ((result: any): T) */

    return result;
  }
  /**
   * The concat method will append values to the chain and return a copy.
   * NOTE: for single values use push()
   * @param {string | number | KeyChain | Array<string>} value is a key or array to join.
   * @return {KeyChain} a clone
   */

  concat(values) {
    let newChain;
    if (values instanceof KeyChain) newChain = this.push(...values.chain);
    else if (Array.isArray(values)) newChain = this.push(...values);
    else newChain = this.push(values);
    return newChain;
  }
  /**
   * The derive method will get a derive key and return a new chain
   * relative to this one.
   * @param {string} value is a derive key.
   * @returns {KeyChain} the derived KeyChain.
   */

  derive(value) {
    const { root, target } = helpers$1.unroot.call(this, value);
    if (root === ROOT) return this.copy(target);
    return helpers$1.trace.call(this, target).pop();
  }
  /**
   * The underive method will return the derive key as if the target
   * derived the source.
   * @param {string?} value is the relative anchor of the derive key.
   * @return {string} is the reverse of the input.
   */

  underive(value) {
    const { root, target } = value
      ? helpers$1.unroot.call(this, value)
      : {
          root: ROOT,
          target: []
        };
    if (root === ROOT)
      return `${ROOT}.${this.join().replace(new RegExp(KeyChain.escape(this.separator), 'g'), '.')}.value`;
    const trace = helpers$1.trace.call(this, target);
    return `this.${trace
      .reverse() // Get Length per Key
      .map(e => e.length) // Detect if length increased or not
      // Choose action that causes such change
      .map((e, i, arr) => {
        const delta = i ? e - arr[i - 1] : 1;
        return delta < 0 ? PARENT : trace[i].peek();
      }) // Remove start key
      .splice(1)
      .join('.')}.value`;
  }
  /**
   * The copy method creates a clone of the chain.
   * @return {KeyChain} a clone
   */

  copy(template) {
    return new KeyChain(template || this.keys, this);
  }
  /**
   * The encode method will convert a key to a common format.
   * @param {string|number} value is a key to convert.
   * @return {string} is the encoded key.
   */

  encode(value) {
    return `${value}`.trim();
  }
  /**
   * The decode method restores the key back as a string.
   * @param {string} value is an encoded key.
   * @return {string} expanded key as string.
   */

  decode(value) {
    return value; // noop
  }
  /**
   * The push method gives a KeyChain with one more level.
   * @param {string|number} value is the key to add.
   * @return {KeyChain} is new chain.
   */

  push(...values) {
    const newChain = this.copy();
    newChain.chain.push(...values.map(this.encode, this));
    return newChain;
  }
  /**
   * The pop method returns a KeyChain with one less level.
   * @return {KeyChain} is a clone.
   */

  pop() {
    const newChain = this.copy();
    newChain.chain.pop();
    return newChain;
  }
  /**
   * The peek method returns the last key in the chain.
   * @param {boolean?} stripNamespace if the key is to be expanded.
   * @return {string} the last key.
   */

  peek(stripNamespace = false) {
    return stripNamespace ? this.key.replace(`${this.namespace}.`, '') : this.key;
  }
  /**
   * The split method will split a string by the separator and encode
   * its keys.
   * @param {string} strval is a string to convert to chain.
   * @return {string[]} is the encoded chain.
   */

  split(strval) {
    return strval.split(this.separator).map(this.encode, this);
  }
  /**
   * Converts this key to its string equivalent.
   * @param {boolean?} strip if numeric keys are to be removed.
   * @param {boolean?} decode if keys are to be restored fully.
   * @return {string} the string equivalent of this key.
   */

  join(strip = false, decode = false) {
    return this.chain // Do not remove first key in case it is BASE_ID
      .filter((x, i) => !strip || !i || isNaN(+x))
      .map(decode ? this.decode : x => x, this)
      .join(this.separator);
  }

  toString() {
    return this.join();
  }
}
KeyChain.BASE_ID = BASE_ID;
KeyChain.DEFAULT_SEPARATOR = DEFAULT_SEPARATOR;
KeyChain.Error = ChainError; // @ts-ignore

KeyChain._helpers = helpers$1;

const SYMBOL = {
  DEFAULT: 'DEFAULT'
};

const makeDatePattern = (time = false) =>
  '^(?:[1-9]\\d{3}(-)(?:(?:0[1-9]|1[0-2])\\1(?:0[1-9]|1\\d|2[0-8])|(?:0[13-9]|1[0-2])\\1(?:29|30)|(?:0[13578]|1[02])(?:\\1)' +
  `31|00[1-9]|0[1-9]\\d|[12]\\d{2}|3(?:[0-5]\\d|6[0-5]))|(?:[1-9]\\d(?:0[48]|[2468][048]|[13579][26])|(?:[2468][048]|[13579][26])00)(?:(-)02(?:\\2)29|-?366))${
    time
      ? '(?:[T ](?:[01]\\d|2[0-3])(:?)[0-5]\\d(?:\\3[0-5]\\d)?(?:\\.\\d{1,6})?(?:Z|[+-][01]\\d(?:\\3[0-5]\\d)?)?)?'
      : ''
  }$`;

const FORMAT = {
  LEI: '^[0-9A-Z]{18}[0-9]{2}$',
  NUMBER: '^-?\\d+$',
  DOUBLE: '^-?((\\d+(\\.\\d*)?)|(\\.\\d*))$',
  DATETIME: makeDatePattern(true),
  DATE: makeDatePattern()
};

const makeSource = modifiers => ({
  nullable: [],
  enabled: [],
  show: [],
  'clone.enabled': [],
  derive: modifiers.derive || [],
  setValue: [],
  setLabel: [],
  readOnly: [],
  copy: [],
  default: {
    'clone.enabled': true,
    setValue: [],
    setLabel: [],
    readOnly: false,
    nullable: modifiers.nullable || false,
    enabled: modifiers.showInternal || !modifiers.internal,
    show: modifiers.showInternal || !modifiers.internal
  },
  extensions: {
    'clone.enabled': true
  }
});

const makeUnion = (fields, chain, modifiers) => ({
  type: 'union',
  label: modifiers.label,
  origLabel: modifiers.label,
  help: modifiers.doc || '',
  options: fields.filter(x => x !== TYPE.DEFAULT).map(x => chain.push(x).join()),
  placeholder: modifiers.placeholder,
  source: makeSource(modifiers),
  internal: modifiers.internal || false,
  nullable: modifiers.nullable || false,
  extensions: modifiers.extensions || [],
  dirty: false,
  readOnly: false,
  error: !modifiers.nullable ? 'This is a required field.' : '',
  enabled: modifiers.showInternal || !modifiers.internal,
  state: modifiers.default == null ? null : modifiers.default
});
const makeEnum = (fields, modifiers) => {
  const options = fields
    .concat(modifiers.enum || [])
    .filter(x => x !== SYMBOL.DEFAULT)
    .map(x => {
      return typeof x === 'object'
        ? x
        : {
            key: x,
            value: x.replace(/_/g, ' ') // RDISFIGI-2905
          };
    });

  if (modifiers.nullable && options && options.length > 0) {
    options.push({
      key: '',
      value: ''
    });
  }

  return {
    type: 'enum',
    label: modifiers.label,
    origLabel: modifiers.label,
    namespace: modifiers.namespace,
    placeholder: modifiers.placeholder,
    help: modifiers.doc || '',
    options,
    internal: modifiers.internal || false,
    nullable: modifiers.nullable || false,
    extensions: modifiers.extensions || [],
    source: makeSource(modifiers),
    dirty: false,
    readOnly: false,
    error: !modifiers.nullable ? 'This is a required field.' : '',
    enabled: modifiers.showInternal || !modifiers.internal,
    init: false,
    state: modifiers.default == null ? null : modifiers.default
  };
};
const makeList = modifiers => ({
  type: 'list',
  label: modifiers.label,
  origLabel: modifiers.label,
  help: modifiers.doc || '',
  base: {},
  split: false,
  internal: modifiers.internal || false,
  nullable: modifiers.nullable || false,
  enabled: modifiers.showInternal || !modifiers.internal,
  readOnly: false,
  source: makeSource(modifiers),
  visible: true,
  init: false,
  state: modifiers.nullable ? null : []
});
const makeMap = modifiers => ({
  type: 'map',
  label: modifiers.label,
  origLabel: modifiers.label,
  help: modifiers.doc || '',
  base: {},
  split: false,
  internal: modifiers.internal || false,
  nullable: modifiers.nullable || false,
  enabled: modifiers.showInternal || !modifiers.internal,
  readOnly: false,
  source: makeSource(modifiers),
  visible: true,
  init: false,
  state: modifiers.nullable ? null : []
});
const makeRecord = (fields, chain, modifiers) => {
  const base = {
    type: 'record',
    label: modifiers.label,
    namespace: modifiers.namespace,
    help: modifiers.doc || '',
    fields: fields.map(x => chain.push(x.name).join()),
    internal: modifiers.internal || false,
    extensions: modifiers.extensions || [],
    nullable: modifiers.nullable || false,
    source: makeSource(modifiers),
    enabled: modifiers.showInternal || !modifiers.internal,
    visible: !!modifiers.visible,
    state: !modifiers.nullable
  }; // @ts-ignore

  return modifiers.unique
    ? _objectSpread2(
        {
          unique: true
        },
        base
      )
    : _objectSpread2(
        {
          unique: false
        },
        base
      );
};
const makeValue = modifiers => ({
  type: 'value',
  label: modifiers.label,
  origLabel: modifiers.label,
  placeholder: modifiers.placeholder,
  help: modifiers.doc || '',
  internal: modifiers.internal || false,
  nullable: modifiers.nullable || false,
  extensions: modifiers.extensions || [],
  source: makeSource(modifiers),
  autocomplete: modifiers.autocomplete,
  dirty: false,
  format: modifiers.format || '',
  pattern:
    modifiers.pattern ||
    (function() {
      switch (modifiers.format) {
        case 'date':
          return FORMAT.DATE;

        case 'datetime':
          return FORMAT.DATETIME;

        case 'lei':
          return FORMAT.LEI;

        default:
          return '';
      }
    })(),
  maxLength: modifiers.length || 0,
  min: modifiers.min,
  max: modifiers.max,
  error: !modifiers.nullable ? 'This is a required field.' : '',
  enabled: modifiers.showInternal || !modifiers.internal,
  readOnly: false,
  init: false,
  state: modifiers.default == null ? null : modifiers.default
});
const makeNumber = modifiers => ({
  type: 'number',
  label: modifiers.label,
  origLabel: modifiers.label,
  help: modifiers.doc || '',
  placeholder: modifiers.placeholder,
  internal: modifiers.internal || false,
  nullable: modifiers.nullable || false,
  extensions: modifiers.extensions || [],
  source: makeSource(modifiers),
  double: modifiers.format === 'double',
  dirty: false,
  min: modifiers.min,
  max: modifiers.max,
  error: !modifiers.nullable ? 'This is a required field.' : '',
  enabled: modifiers.showInternal || !modifiers.internal,
  readOnly: false,
  state: modifiers.default == null ? null : modifiers.default
});
const makeBool = modifiers => ({
  type: 'bool',
  label: modifiers.label,
  origLabel: modifiers.label,
  help: modifiers.doc || '',
  internal: modifiers.internal || false,
  nullable: modifiers.nullable || false,
  extensions: modifiers.extensions || [],
  source: makeSource(modifiers),
  dirty: false,
  error: !modifiers.nullable ? 'This is a required field.' : '',
  enabled: modifiers.showInternal || !modifiers.internal,
  readOnly: false,
  state: (function() {
    if (typeof modifiers.default === 'boolean') return modifiers.default;

    switch (modifiers.default) {
      case 'false':
        return false;

      case 'true':
        return true;

      default:
        return null;
    }
  })()
});
var nodes = {
  makeEnum,
  makeList,
  makeMap,
  makeRecord,
  makeUnion,
  makeValue,
  makeNumber,
  makeBool
};

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
const reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
const reHasRegExpChar = RegExp(reRegExpChar.source);
/**
 * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
 * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
 *
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @see escape, escapeRegExp, unescape
 * @example
 *
 * escapeRegExp('[lodash](https://lodash.com/)')
 * // => '\[lodash\]\(https://lodash\.com/\)'
 */

function escapeRegExp(string) {
  return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string || '';
}

const BASE_ID$1 = KeyChain.BASE_ID;
const MAP_ID = new KeyChain('_MapKey').join();
const SPLIT_ID = new KeyChain('_Split').join();
const REF_TYPE = 'com.bloomberg.gdw.ext.ReferenceDatasetLookupField';
const AUC_TYPE = 'com.bloomberg.gdw.ext.AutocompleteField';
const toMapId = id => (id instanceof KeyChain ? id : new KeyChain(id)).push(MAP_ID).join();
const toSplitId = (uid, id) =>
  new KeyChain(id)
    .push(uid())
    .push(SPLIT_ID)
    .join();
const staticIsOf = base => {
  const map = base.reduce((a, x) => {
    a[x] = true;
    return a;
  }, {});
  return value => !!map[value];
};
const isValue = staticIsOf(['value', 'enum', 'bool', 'number', 'long']);
const isDouble = staticIsOf(['float', 'double']);
function ifExtended(node) {
  if (!node) return null;

  switch (node.type) {
    case 'value':
    case 'bool':
    case 'number':
    case 'enum':
    case 'union':
    case 'record':
      return node;

    default:
      return null;
  }
}
function ifTemplated(node) {
  if (!node) return null;

  switch (node.type) {
    case 'map':
    case 'list':
      return node;

    default:
      return null;
  }
}
function ifValue(node) {
  if (!node) return null;

  switch (node.type) {
    case 'value':
    case 'bool':
    case 'number':
    case 'enum':
    case 'union':
      return node;

    default:
      return null;
  }
}
function ifTestable(node) {
  if (!node) return null;

  switch (node.type) {
    case 'value':
    case 'bool':
    case 'number':
    case 'enum':
    case 'union':
    case 'map':
      return node;

    case 'list':
      return node.unique ? node : null;

    default:
      return null;
  }
}

const helpers$2 = {
  genNodesByPaths: function*(data, paths) {
    const seeds = paths.slice(0, 1);

    for (let i = 1; i < paths.length; i++) {
      const next = k => paths[i].rebase(k);

      for (let j = seeds.length; j > 0; ) {
        j--;
        const key = String(seeds.splice(0, 1)[0]),
          node = has$2(data, key) && ifTemplated(data[key]);
        /* istanbul ignore if */

        if (!node) continue;
        seeds.push(...(node.state || []).map(next));
      }
    }

    for (let i = 0; i < seeds.length; i++) {
      const key = String(seeds[i]);
      /* istanbul ignore else */

      if (has$2(data, key))
        yield {
          key,
          node: data[key],
          base: false,
          data
        };
    }
  },
  genNodeIfFound: function*(data, stack, returnListOrMap, { key, base, paths }) {
    paths = paths.concat(new KeyChain(key));
    const isTemplate = data !== base,
      node = base[key],
      templatedNode = ifTemplated(node);

    if (!returnListOrMap && templatedNode) {
      stack.splice(0, stack.length, {
        data: base,
        key: KeyChain.BASE_ID,
        base: templatedNode.base,
        paths
      });
      return;
    }

    yield {
      key,
      node,
      base: isTemplate,
      data: base
    }; // Find all nodes that are part of this list chain

    if (isTemplate) yield* helpers$2.genNodesByPaths(data, paths);
  },

  getNextIfNotFound(stack, { key, base, paths }) {
    const chain = new KeyChain(key);

    for (const newKey in base) {
      const node = has$2(base, newKey) && ifTemplated(base[newKey]);
      if (!node || !chain.startsWith(newKey)) continue;
      stack.splice(0, stack.length, {
        data: node.base,
        key: String(chain.rebase(newKey)),
        base: node.base,
        paths: paths.concat(new KeyChain(newKey))
      });
      break;
    }
  }
};
const genNodes = function*(data, source, returnListOrMap = false) {
  const stack = [
    {
      base: data,
      paths: [],
      key: source
    }
  ];

  while (stack.length) {
    const opts = stack.pop();
    if (has$2(opts.base, opts.key)) yield* helpers$2.genNodeIfFound(data, stack, returnListOrMap, opts);
    else if (KeyChain.isUnique(source)) return;
    else helpers$2.getNextIfNotFound(stack, opts);
  }
};
genNodes._helpers = helpers$2;

const helpers$3 = {
  /**
   * This is a private utility to look for boolean properties who are derived
   * by another field.
   * @param {string} type is the kind of extension to test for
   * @param {StoreData} data is the data map of the datamodel.
   * @param {string} target is the target node key chain
   * @param {string} source is the source node key chain
   * @returns {boolean} if the source node calls for the the extension to be true
   */
  boolExtension(type, data, target, source) {
    const node = has$2(data, source) && ifExtended(data[source]);
    if (!node || !node.enabled) return false;
    const isTarget = staticIsOf([target, new KeyChain(target).join(true)]);
    return node.extensions.some(ext => {
      if (ext.type !== type || !isTarget(ext.target)) return false;
      let state = node.state;
      if (ext.pattern && state != null && typeof state !== 'boolean') state = new RegExp(ext.pattern).test(`${state}`);
      return Boolean(ext.not ? !state : state);
    });
  },

  convertToEnumSet(node, data, key) {
    const templateNode = node.base[KeyChain.BASE_ID];
    /* istanbul ignore if*/

    if (templateNode.type !== 'enum') return;
    const chain = new KeyChain(key),
      isTrue = staticIsOf(
        (
          node.state ||
          /* istanbul ignore next */
          []
        )
          .map(enumKey => {
            const enumNode = has$2(data, enumKey) && data[enumKey];
            /* istanbul ignore if*/

            if (!enumNode || enumNode.type !== 'enum') return null; // Remove child from data

            delete data[enumKey];
            return enumNode.state;
          })
          .filter(Boolean)
      );
    let enumSetNodeState = false; // @ts-ignore

    const setNode = makeRecord(
      templateNode.options.map(option => {
        const optionName = constToCamel(option.key),
          optionKey = chain.push(optionName).join();
        const enumNode = makeBool({
          label: option.value,
          nullable: false,
          doc: templateNode.help
        });
        enumNode.state = isTrue(option.key); // The enum set node's state should be true (opened up) if any of its options is checked.

        enumSetNodeState = enumSetNodeState || enumNode.state;
        data[optionKey] = enumNode;
        return {
          name: optionName
        };
      }),
      chain,
      {
        label: chain.title,
        unique: true,
        nullable: node.nullable,
        doc: node.help,
        internal: node.internal,
        visible: true
      }
    );
    setNode.source = node.source;
    setNode.state = enumSetNodeState;
    data[key] = setNode;
  }
};
/**
 * @typedef {Object} MutateProps
 * @param {string} source is the field being altered.
 * @param {(boolean|null)?} [value=null] is the value the default should be changed to if given.
 */

/**
 * This function will derive if the field is displayed. Result is true if any deriving
 * field return true or if the default is true.
 * @param {MutateProps} props are obtions to this function.
 * @param {Store} store is the datamodel.
 * @return {Store} is the datamodel.
 */

const enabled = ({ source, value }, store) => {
  const self = enabled;

  for (const access of genNodes(store.data, source, true)) {
    const node = !(value == null && access.base) && ifExtended(access.node);
    if (!node) continue;
    else if (value != null) node.source.default[self.prop] = value;
    node[self.prop] =
      node.source.default[self.prop] ||
      node.source[self.prop].some(helpers$3.boolExtension.bind(null, enabled.type, access.data, access.key));
  }

  return store;
};

enabled.type = 'display';
enabled.prop = 'enabled';
/**
 * @typedef {Object} MutateProps
 * @param {string} source is the field being altered.
 * @param {(boolean|null)?} [value=null] is the value the default should be changed to if given.
 */

/**
 * This function will derive if the field is shown. Result is true if any deriving
 * field return true or if the default is true.
 * @param {MutateProps} props are obtions to this function.
 * @param {Store} store is the datamodel.
 * @return {Store} is the datamodel.
 */

const show = ({ source, value }, store) => {
  const self = show;

  for (const access of genNodes(store.data, source, true)) {
    const node = !(value == null && access.base) && ifExtended(access.node);
    if (!node) continue;
    else if (value != null) node.source.default[self.prop] = value;
    node[self.prop] =
      node.source.default[self.prop] ||
      node.source[self.prop].some(helpers$3.boolExtension.bind(null, enabled.type, access.data, access.key));

    if (value != null) {
      node[self.prop] = value;
    }
  }

  return store;
};

show.type = 'show';
show.prop = 'show';
/**
 * This function will derive if the field is read-only. Result is true if any deriving
 * field return true or if the default is true.
 * @param {MutateProps} props are obtions to this function.
 * @param {Store} store is the datamodel.
 * @return {Store} is the datamodel.
 */

const readOnly = ({ source, value }, store) => {
  const self = readOnly;

  for (const access of genNodes(store.data, source, true)) {
    const node = !(value == null && access.base) && ifExtended(access.node);
    if (!node) continue;
    else if (value != null) node.source.default[self.prop] = value;
    node[self.prop] =
      node.source.default[self.prop] ||
      node.source[self.prop].some(helpers$3.boolExtension.bind(null, self.type, access.data, access.key));
  }

  return store;
};

readOnly.type = 'readOnly';
readOnly.prop = 'readOnly';
/**
 * This function will derive if the field is to be reset. Result is true if any deriving
 * field return true or if the default is true.
 * @param {MutateProps} props are obtions to this function.
 * @param {Store} store is the datamodel.
 * @return {Store} is the datamodel.
 */

const reset = ({ source, value }, store) => {
  const self = reset;

  for (const access of genNodes(store.data, source)) {
    const node = !(value == null && access.base) && ifValue(access.node);
    if (!node) continue;
    else if (value != null) node.source.default[self.prop] = value;
    node.source.extensions[self.prop] =
      node.source.default[self.prop] ||
      node.source[reset.prop].some(helpers$3.boolExtension.bind(null, self.type, access.data, access.key));
  }

  return store;
};

reset.type = 'reset';
reset.prop = 'reset';
/**
 * This function will set the collapse value of a field.
 * @param {MutateProps} props are obtions to this function.
 * @param {Store} store is the datamodel.
 * @return {Store} is the datamodel.
 */

const collapse = ({ source, value }, store) => {
  const self = collapse;

  for (const access of genNodes(store.data, source, true)) {
    const node = has$2(store.data, source) && ifExtended(access.node);
    if (!node || node.type !== 'record') continue; // We set visible to !value because a collapsed record means its not visible and an expanded record means its visible

    const visible = value !== undefined ? !value : node[self.prop];
    node[self.prop] = visible;
    break;
  }

  return store;
};

collapse.type = 'collapse';
collapse.prop = 'visible';
/**
 * This function will derive if the field is required. Result is true if any deriving
 * field return true or if the default is true.
 * NOTE: Store property is `nullable` which is the opposite of `required`
 * @param {MutateProps} props are obtions to this function.
 * @param {Store} store is the datamodel.
 * @return {Store} is the datamodel.
 */

const nullable = ({ source, value }, store) => {
  const self = nullable;

  for (const access of genNodes(store.data, source, true)) {
    const node = !(value == null && access.base) && ifExtended(access.node);
    if (!node) continue;
    else if (value != null) node.source.default[self.prop] = !value;
    node[self.prop] =
      node.source.default[self.prop] &&
      !node.source[self.prop].some(helpers$3.boolExtension.bind(null, self.type, access.data, access.key)); // If a record is required, then the state must be true. Otherwise it will never show.

    if (!node[self.prop] && node.type === 'record') node.state = true;
  }

  return store;
};

nullable.type = 'require';
nullable.prop = 'nullable';
/**
 * This function will derive if the field is to be cloned. Result is true if any deriving
 * field return true or if the default is true.
 * @param {MutateProps} props are obtions to this function.
 * @param {Store} store is the datamodel.
 * @return {Store} is the datamodel.
 */

const clone = ({ source, value }, store) => {
  const self = clone;

  for (const access of genNodes(store.data, source)) {
    const node = !(value == null && access.base) && ifValue(access.node);
    if (!node) continue;
    else if (value != null) node.source.default[self.prop] = value;
    node.source.extensions[self.prop] =
      node.source.default[self.prop] ||
      node.source[clone.prop].some(helpers$3.boolExtension.bind(null, self.type, access.data, access.key));
  }

  return store;
};

clone.type = 'clone.enabled';
clone.prop = 'clone.enabled';

const setValue = ({ source, rule, key, value }, store) => {
  for (const access of genNodes(store.data, source)) {
    const node = has$2(store.data, source) && ifExtended(access.node);
    if (!node) continue;

    switch (true) {
      // enum set or record type
      case node.type === 'enum' && 'unique' in node:
      case node.type === 'record': {
        // check all the fields and if they match the key path, set their state
        const re = new RegExp(`^${key}$`);
        const fullRe = new RegExp(`^${escapeRegExp(source)}|${key}$`);

        for (const id of node.fields) {
          // field exists in data
          if (has$2(store.data, id) && (re.test(id) || fullRe.test(id))) {
            for (const selected of genNodes(store.data, id)) {
              // make sure it's a value type
              const valueNode = ifValue(selected.node);

              if (valueNode) {
                valueNode.state = value || null;
              }
            }
          }
        }

        break;
      }
      // value type

      case !!ifValue(node): {
        node.state = value || null;
        break;
      }

      default:
        continue;
    }
  }

  return store;
};

setValue.type = 'setValue';
setValue.prop = 'setValue';

const setLabel = ({ source, rule, value }, store) => {
  for (const access of genNodes(store.data, source)) {
    const node = has$2(store.data, source) && ifExtended(access.node);
    if (!node) continue;
    const re = new RegExp(`${rule}`);
    const label = node.origLabel ? node.origLabel : node.label;

    if (re.test(label)) {
      node.origLabel = label;
      node.label = label.replace(re, value || '');
    }
  }

  return store;
};

setLabel.type = 'setLabel';
setLabel.prop = 'setLabel';

const unique = ({ source, value }, store) => {
  for (const { node, data, key } of genNodes(store.data, source, true)) {
    /* istanbul ignore if */
    if (!node || node.type !== 'list') continue; // $FlowFixMe

    if (value == null && typeof node.unique !== 'string') node.unique = !node.unique;
    // $FlowFixMe
    else if (value != null) node.unique = value;
    if (node.unique === true) helpers$3.convertToEnumSet(node, data, key);
  }

  return store;
};

const reorder = ({ source, from, to }, store) => {
  if (from < 0 || to < 0 || from === to) return store;
  const node = store.data[source];
  if (
    !node ||
    (node.type !== 'list' && node.type !== 'map') ||
    !node.state ||
    from >= node.state.length ||
    to >= node.state.length
  )
    return store;
  node.state.splice(to, 0, node.state.splice(from, 1)[0]);
  return store;
};
/* istanbul ignore next: just a shortcut */

const init = ({ source }, store) => {
  [clone, nullable, enabled, collapse].forEach(task =>
    task(
      {
        source
      },
      store
    )
  );
};

const mutate = {
  unique,
  [setValue.prop]: setValue,
  setValue,
  [setLabel.prop]: setLabel,
  setLabel,
  [readOnly.type]: readOnly,
  [reset.type]: reset,
  [enabled.type]: enabled,
  [show.type]: show,
  [nullable.type]: nullable,
  [collapse.type]: collapse,
  collapse,
  [clone.type]: clone,
  clone: {
    enabled: clone
  },
  reorder,
  init
};

mutate._helpers = helpers$3;

const FIELD_MAP = {
  display: 'enabled',
  show: 'show',
  readOnly: 'readOnly',
  require: 'nullable',
  'clone.enabled': 'clone.enabled',
  'set.enabled': 'set.enabled'
};

const hookClone = ({ source, target }, store) => {
  if (!has$2(store.data, target) || !has$2(store.data, source)) return store;
  const node = ifExtended(store.data[source]);
  if (!node || node.type === 'record') return store;
  node.extensions.push({
    type: 'clone',
    target
  });
  return store;
};

const hookReset = ({ source, target }, store) => {
  if (!has$2(store.data, target) || !has$2(store.data, source)) return store;
  const node = ifExtended(store.data[source]); // Reset only works for enum and value type for now

  if (!node || ['enum', 'value'].indexOf(node.type) < 0) return store;
  node.extensions.push({
    type: 'reset',
    target
  });
  return store;
};

const hookSet = (type, opts, store) => {
  const { source, target } = opts;
  if (!has$2(store.data, source)) return store;
  const node = ifExtended(store.data[source]);
  if (!node || (type === 'setValue' && node.type === 'record')) return store;
  node.extensions.push(
    _objectSpread2(
      {
        type,
        target,
        not: false
      },
      opts
    )
  );
  return store;
};

const hookCopy = (opts, store) => {
  const { source, target } = opts;
  if (!has$2(store.data, source)) return store;
  const node = ifExtended(store.data[source]);
  if (!node || node.type === 'record') return store;
  node.extensions.push(
    _objectSpread2(
      {
        type: 'copy',
        target,
        not: false
      },
      opts
    )
  );
  return store;
};

const hookDerive = ({ source }, store) => {
  if (!has$2(store.data, source)) return store;
  const node = ifValue(store.data[source]);
  if (!node || node.type === 'union') return store;
  const chain = new KeyChain(source);
  node.source.derive = node.source.derive
    .map(derive => {
      const target = chain.derive(derive).join();
      if (!has$2(store.data, target)) return null;
      const node = ifExtended(store.data[target]);
      if (!node || node.type === 'record') return null;
      node.extensions.push({
        type: 'derive',
        target: source
      });
      return target;
    })
    .filter(Boolean);
  return store;
};

const helpers$4 = {
  genTargetNodes: function*(type, data, { key, node, base }, _ref) {
    let { target } = _ref,
      opts = _objectWithoutProperties(_ref, ['target']);

    const chain = new KeyChain(key);

    if (!target) {
      // Having `sourceAccess.base` means we are in the base, do not expand.
      if (base) return;

      for (const ext of node.extensions) {
        if (ext.type !== type) continue;
        if (KeyChain.isRelative(ext.target)) ext.target = String(chain.derive(ext.target));
        yield* genNodes(data, ext.target);
      }

      return;
    }

    const isRelative = KeyChain.isRelative(target);
    if (isRelative && !base) target = String(chain.derive(target)); // $FlowFixMe

    node.extensions.push(
      _objectSpread2(
        {
          type,
          target,
          not: false
        },
        opts
      )
    );
    if (isRelative && base) return;
    yield* genNodes(data, target);
  },

  execBoolean(type, sourceAccess, opts, store) {
    for (const targetAccess of helpers$4.genTargetNodes(type, store.data, sourceAccess, opts)) {
      const node = ifExtended(targetAccess.node);
      /* istanbul ignore if */

      if (!node) break;
      const src = node.source[FIELD_MAP[type]];
      /* istanbul ignore if: Avoid duplicates */

      if (isOf(src, sourceAccess.key)) continue;
      src.push(sourceAccess.key); // @ts-ignore: Base will be updated called when initiated

      if (!targetAccess.base)
        mutate[type](
          {
            source: targetAccess.key
          },
          store
        );
    }
  }
};
/**
 * The HookBoolean connects two fields with a boolean property extension.
 * NOTE: See mutate for boolean extensions at work.
 * @param {string} type of the boolean extension.
 * @param {string} field is the name that extension works upon.
 * @param {HookBooleanOpts} opts are settings to this function.
 * @param {Store} store is the datamodel.
 * @return {Store} is the datamodel.
 */

const hookBoolean = (type, opts, store) => {
  const { source } = opts;

  for (const _ref2 of genNodes(store.data, source, isOf(['display', 'require', 'readOnly'], type))) {
    const { node } = _ref2,
      sourceAccess = _objectWithoutProperties(_ref2, ['node']);

    const sourceNode = ifExtended(node); // Having `sourceAccess.base` means we are in the base, do not expand.

    /* istanbul ignore if */

    if (!sourceNode) break;
    else if (sourceAccess.base && !opts.target) continue;
    helpers$4.execBoolean(
      type,
      _objectSpread2(
        {
          node: sourceNode
        },
        sourceAccess
      ),
      opts,
      store
    );
  }

  return store;
};

hookClone.enabled = hookBoolean.bind(null, 'clone.enabled');
/* istanbul ignore next: just a shortcut */

const init$1 = ({ source }, store) => {
  hookDerive(
    {
      source
    },
    store
  );

  for (const type in FIELD_MAP) {
    // @ts-ignore
    hookBoolean(
      type,
      {
        source
      },
      store
    );
  }
};

const extend = {
  clone: hookClone,
  reset: hookReset,
  setValue: hookSet.bind(null, 'setValue'),
  setLabel: hookSet.bind(null, 'setLabel'),
  copy: hookCopy,
  derive: hookDerive,
  readOnly: hookBoolean.bind(null, 'readOnly'),
  display: hookBoolean.bind(null, 'display'),
  show: hookBoolean.bind(null, 'show'),
  require: hookBoolean.bind(null, 'require'),
  init: init$1
};

extend._helpers = helpers$4;

var Store;

(function(Store) {
  let EMode;

  (function(EMode) {
    EMode['EDIT'] = 'edit';
    EMode['VIEW'] = 'view';
    EMode['LOCK'] = 'lock';
  })((EMode = Store.EMode || (Store.EMode = {})));
})(Store || (Store = {}));

const valueFormats = fieldType => valueFormats.TYPE[fieldType] || '';

valueFormats.TYPE = {
  [TYPE.DATETIME]: 'datetime',
  [TYPE.DATE]: 'date',
  [TYPE.LEI]: 'lei'
}; // $FlowFixMe

const valuePlaceholders = fieldType => valuePlaceholders.TYPE[fieldType];

valuePlaceholders.TYPE = {
  [TYPE.DATETIME]: 'yyyy-mm-dd HH:MM:SS',
  [TYPE.DATE]: 'yyyy-mm-dd'
};

const buildRecord = (stack, { store, chain, arrayChain }) => field => {
  stack.push({
    field,
    store,
    chain: chain.push(field.name),
    arrayChain: arrayChain.push(field.name)
  });
  return field;
};

const ERROR_CODES$2 = {
  INVAL_SCHEM: 'Unrecognized schema was given, store cannot be built.',
  INVAL_UNION: 'Union has no subtypes left.',
  INVAL_NESUN: 'Nested unions are not supported.',
  INVAL_COMPL: 'Union of records or enums without names is not supported.',
  INVAL_ARRAY: 'Arrays and maps cannot have either as children.'
};

class BuildError extends Error {
  constructor(code) {
    super(ERROR_CODES$2[code]);
    this.code = code; // Remove class constructor from stack trace

    Error.captureStackTrace && Error.captureStackTrace(this, BuildError);
  }
}

BuildError.Codes = ERROR_CODES$2;
BuildError.Codes = ERROR_CODES$2;
const helpers$5 = {
  flatReduce(acc, flat) {
    const key = new KeyChain(flat.path.split(/\s*\|\s*/g)).join();

    if (flat.TYPE === REF_TYPE) {
      const searchPayload = flat.type.searchPayload || '';
      flat.deriveSource = [...new Set(searchPayload.match(/(?:\$Root|this)\..+?\.value/g))];
      flat.enum = flat.enum || [];
    }

    acc[key] = flat;
    return acc;
  },

  makeModifiers(modifiers, inherited, key) {
    Object.assign(modifiers, inherited);
    if (!has$2(this._flats, key)) return modifiers;
    const flat = this._flats[key];

    if (flat.TYPE === REF_TYPE) {
      modifiers.enum = (flat.enum || []).map(({ value: key, description: value }) => ({
        key,
        value
      }));
      modifiers.derive = flat.deriveSource;
    } else if (flat.TYPE === AUC_TYPE)
      modifiers.autocomplete = {
        filter: flat.type.client.filter,
        options: flat.enum || []
      };

    if (flat.validate) {
      modifiers.min = flat.validate.min;
      modifiers.max = modifiers.length = flat.validate.max;
      modifiers.pattern = flat.validate.regexp;
    }

    return modifiers;
  },

  makeUnion(fieldType, { stack, key, modifiers, store, chain, arrayChain }) {
    store[key] = nodes.makeUnion(
      fieldType.map(unionField => {
        const field = {
          name: '',
          type: '',
          doc: ''
        };
        if (Array.isArray(unionField)) throw new BuildError('INVAL_NESUN');
        else if (typeof unionField === 'object') {
          field.name = unionField.type;
          field.type = unionField;
        } else field.type = field.name = unionField;
        stack.push({
          store,
          field,
          chain: chain.push(field.name),
          arrayChain: arrayChain.push(field.name)
        });
        return field.name;
      }),
      chain,
      modifiers
    );
  },

  makeRefDs(fieldType, { key, modifiers, store }) {
    modifiers.refDs = fieldType.refDs;
    store[key] = modifiers.enum ? nodes.makeEnum([], modifiers) : nodes.makeValue(modifiers);
  },

  makeListOrMap(fieldType, { stack, key, modifiers, field, store, arrayChain }) {
    const substore = (store[key] = fieldType.type === 'map' ? nodes.makeMap(modifiers) : nodes.makeList(modifiers));
    const childChain = new KeyChain(0);
    stack.push({
      store: substore.base,
      field: {
        name: field.name,
        type: fieldType.type === 'map' ? fieldType.values : fieldType.items,
        doc: field.doc
      },
      chain: childChain,
      arrayChain
    });
  },

  makeRecordOrEnum(fieldType, { stack, key, modifiers, store, chain, arrayChain }) {
    const record = this.adapter.data[fieldType];
    if (record.type === 'enum') store[key] = nodes.makeEnum(record.symbols, modifiers);
    else if (
      record.fields.length === 1 &&
      record.fields[0].name === 'value' &&
      Avro.ifAlias(record.fields[0].name, this)
    )
      stack.push({
        field: _objectSpread2({}, record.fields[0], {
          name: record.name
        }),
        store,
        chain,
        arrayChain,
        inheritedModifiers: modifiers
      });
    else
      store[key] = nodes.makeRecord(
        record.fields.map(
          buildRecord(stack, {
            store,
            chain,
            arrayChain
          })
        ),
        chain,
        modifiers
      );
  },

  makeValue(fieldType, { key, modifiers, field, store }) {
    if (fieldType === TYPE.BOOL) {
      modifiers.format = 'boolean';
      store[key] = nodes.makeBool(modifiers);
    } else if (fieldType === TYPE.NUMBER || fieldType === TYPE.LONG || isDouble(fieldType)) {
      modifiers.format = fieldType === TYPE.NUMBER || fieldType === TYPE.LONG ? 'number' : 'double';
      store[key] = nodes.makeNumber(modifiers);
    } else {
      modifiers.format = valueFormats(fieldType) || valueFormats(field.name);
      modifiers.placeholder = valuePlaceholders(fieldType) || valuePlaceholders(field.name) || modifiers.placeholder;
      store[key] = nodes.makeValue(modifiers);
    }
  },

  execute(opts) {
    const fieldType = opts.field.type;
    if (Array.isArray(fieldType)) helpers$5.makeUnion.call(this, fieldType, opts);
    else if (typeof fieldType === 'object' && fieldType.type === 'string')
      helpers$5.makeRefDs.call(this, fieldType, opts);
    else if (typeof fieldType === 'object') helpers$5.makeListOrMap.call(this, fieldType, opts);
    else if (has$2(this.adapter.data, fieldType)) helpers$5.makeRecordOrEnum.call(this, fieldType, opts);
    else helpers$5.makeValue.call(this, fieldType, opts);
  }
};
/**
 * @class
 * The Builder is a utility class that is used to construct the store object
 * from the Avro schema and its extensions.
 */

class Builder {
  /**
   * @param {object[]} records are the avro records.
   * @param {string} root is the BBDS schema name.
   * @param {object[]} opts.extensions are the flattened extensions.
   * @param {string} opts.defaultPlaceholder the default placeholder text.
   */
  constructor(avro, { extensions = [], internal = false, defaultPlaceholder } = {}) {
    /* istanbul ignore else */
    if (!(avro instanceof Avro)) avro = new Avro(avro.schema, avro);
    this.adapter = avro;
    this.internal = internal;
    this.extensions = extensions;
    this.defaultPlaceholder = defaultPlaceholder;
  }
  /**
   * The build method returns the store object.
   */

  build() {
    // Initialize store
    this.store = {
      root: this.adapter.root,
      data: {},
      label: {},
      mode: Store.EMode.EDIT
    }; // Massage Derive Extensions and Convert to Object

    this._flats = this.extensions.reduce(helpers$5.flatReduce, {});
    const seed = this.adapter.data[this.adapter.root];
    const chain = new KeyChain();
    const stack = [];
    if (!seed || seed.type === 'enum') throw new BuildError('INVAL_SCHEM');
    seed.fields.forEach(
      buildRecord(stack, {
        store: this.store.data,
        chain,
        arrayChain: chain
      })
    );

    while (stack.length) {
      const { field, store, chain, arrayChain, inheritedModifiers = null } = stack.pop();
      helpers$5.execute.call(this, {
        stack,
        field,
        store,
        chain,
        arrayChain,
        key: chain.join(),
        modifiers: helpers$5.makeModifiers.call(
          this,
          {
            label: chain.title,
            doc: field.doc,
            default: field.default,
            internal: field.internal,
            showInternal: this.internal,
            nullable: !!field.nullable,
            placeholder: this.defaultPlaceholder,
            visible: true,
            // Store namespace if needed
            namespace: chain.namespace
          },
          inheritedModifiers,
          arrayChain.join(true)
        )
      });
    }

    Object.keys(this.store.data).forEach(source =>
      extend.derive(
        {
          source
        },
        this.store
      )
    );
    delete this._flats;
    return this.store;
  }
}

Builder.Error = BuildError; // @ts-ignore

Builder._helpers = helpers$5;

const NOOP_ACTION = () => {};
/**
 * This private function will make fields easier to access by mapping reduced
 * values to them.
 * @param {string[]} fields is an array of keys
 * @param {string} dataset is the BBDS dataset name
 */

const fieldReduce = fields =>
  fields.reduce((acc, field) => {
    acc[new KeyChain(field).setSeparator(' | ').join(true, true)] = field;
    return acc;
  }, {});
/**
 * The Deriver will fields and an extension and will apply that extension to
 * the store.
 * @class
 */

class Deriver {
  /**
   * @param {(DeriverOpts|Deriver)} opts are the settings for this class.
   */
  constructor({ type = '', fields = [], extensions = [], callback = NOOP_ACTION }) {
    this.fields = fields;
    this.extensions = extensions;
    this.callback = callback;
    this.type = type;
  }

  transform(store) {
    this._paths = fieldReduce(this.fields);
    this.store = store;
    this.extensions.forEach(flat => {
      if (!flat || flat.TYPE !== this.type || !has$2(this._paths, flat.path)) return;
      const id = this._paths[flat.path];
      if (!has$2(store.data, id)) return;
      this.callback(id, flat);
    });
    return store;
  }
  /**
   * Filter will reduce the extensions to just what the fields specify
   * to reduce work at derive time.
   */

  static filter(fields, extensions) {
    const paths = fieldReduce(fields);
    return extensions.filter(({ path }) => has$2(paths, path));
  }
}

const helpers$6 = {
  // Reduce sources and targets to a single map of possible conflict keys
  reduceGraphs({ source, target }) {
    const conflicts = {};
    let isCandidate = false;
    [...source, ...target].forEach(key => {
      const liteKey = new KeyChain(key).join(true);
      if (liteKey === key) return;
      else if (has$2(conflicts, liteKey))
        throw new Error('Unexpected graphs passed in, should not have self conflicting keys in a graph.');
      isCandidate = true;
      conflicts[liteKey] = key;
    });
    return isCandidate ? conflicts : null;
  },

  findNextConflictFreeIndex(candidates, source) {
    const candidate = candidates[source];
    if (!candidate)
      return {
        candidate,
        target: source - 1
      };
    let target = -1;
    candidates.some((otherCandidate, index) => {
      if (index === source) return true;
      // null candidates are conflict free, otherwise if no fields overlap for the different key.
      else if (
        !otherCandidate ||
        !Object.keys(otherCandidate).some(key => has$2(candidate, key) && otherCandidate[key] !== candidate[key])
      ) {
        target = index;
        return true;
      }
      return false;
    });
    return {
      candidate,
      target
    };
  },

  hasLiteKey(key) {
    const liteKey = new KeyChain(key).join(true);

    if (liteKey !== key) {
      if (!has$2(this.store.next, liteKey)) this.store.next[liteKey] = [];
      else if (this.store.next[liteKey].indexOf(key) >= 0) return null;
      this.store.next[liteKey].push(key);
    }

    return liteKey;
  },

  stackNextNode(stack, key, seed, node) {
    if (node.source.derive.length) {
      if (seed && this.store.target.indexOf(key) < 0) this.store.target.push(key);
      node.source.derive.forEach(source => {
        if (this.store.source.indexOf(source) < 0) this.store.source.push(source);
        if (!stack.some(({ key }) => key === source))
          stack.push({
            key: source,
            seed: false
          });
      });
    }
  },

  derive(stack, seed, node) {
    if (!seed) return;
    node.extensions.forEach(({ type, target }) => {
      if (type !== 'derive') return;
      // If this field was labeled as a seed then it must be a triggering source.
      else if (this.store.target.indexOf(target) < 0) this.store.target.push(target);
      stack.push({
        key: target,
        seed: false
      });
    });
  }
};
/**
 * The Grapher will get a seed id or ids and help obtain all connected fields
 * that need to be extended.
 * @class
 */

class Grapher {
  /**
   * Fields that will get included are those that derive the seed or are derived from the seed.
   * @param {(GrapherOpts|Grapher)} opts are the configration of this class
   */
  constructor({ fields = ['data'], ignore = [] } = {}) {
    this.fields = fields;
    this.ignore = ignore;
  }

  transform(store) {
    this._data = store.data;
    const ignore = new Set(this.ignore);
    this.store = {
      source: [],
      target: [],
      next: {}
    };
    const stack = this.fields.map(key => ({
      key,
      seed: true
    }));

    while (stack.length) {
      const { key, seed = false } = stack.pop();
      if (ignore.has(key) || !has$2(this._data, key)) continue;
      const node = ifExtended(this._data[key]);
      if (!node || node.type === 'record') continue; // Ensure that no conflicting keys are touched.

      if (!helpers$6.hasLiteKey.call(this, key)) continue; // Ensures this field is not touched twice

      ignore.add(key); // If this field is derived it will have derive field

      helpers$6.stackNextNode.call(this, stack, key, seed, node); // This field will have `derive` extension if it derives another field.

      helpers$6.derive.call(this, stack, seed, node);
    } // Cleanup

    delete this._data;
    return this.store;
  }
  /**
   * A static function to help extract all deriving fields in the datamodel.
   * @param {Store} store is the datamodel.
   * @returns {string[]} is a list of all deriving keys
   */

  static scan(store) {
    return Object.keys(store.data).filter(key => {
      const node = ifExtended(store.data[key]);
      if (!node || node.type === 'record') return false;
      return node.extensions.some(({ type }) => type === 'derive');
    });
  }
  /**
   * Will combine combine lists of sources and targets.
   * @param {GrapherModel[]} graphs is the list of sources and targets.
   * @returns {GrapherModel[]} a reduced list (hopefully).
   */

  static optimize(graphs) {
    const candidates = graphs.map(helpers$6.reduceGraphs); // Join if no conflict

    for (let source = graphs.length; source > 0; ) {
      source--;
      const { candidate, target } = helpers$6.findNextConflictFreeIndex(candidates, source);
      if (target < 0) continue; // Merge conflicts together

      if (candidate) candidates[target] = candidates[target] ? Object.assign(candidates[target], candidate) : candidate; // Merge graphs together

      const sourceGraph = graphs[source],
        targetGraph = graphs[target];
      targetGraph.source = [...new Set([...targetGraph.source, ...sourceGraph.source])];
      targetGraph.target = [...new Set([...targetGraph.target, ...sourceGraph.target])]; // Cleanup

      graphs.splice(source, 1);
    }
  }
} // @ts-ignore

Grapher._helpers = helpers$6;

const helpers$7 = {
  nextListAdd(store, base, collapsed, getId) {
    return Object.keys(base).map(nodeKey => {
      const cloneId = getId(nodeKey);
      const child = JSON.parse(JSON.stringify(base[nodeKey]));
      store.data[cloneId] = child;
      if (child.type === 'union') child.options = child.options.map(getId);
      else if (child.type === 'record') {
        /* istanbul ignore else */
        if (nodeKey === BASE_ID$1) child.visible = !collapsed;
        child.fields = child.fields.map(getId);
      } else if (child.type !== 'split' && child.type !== 'map' && child.type !== 'list') {
        child.extensions = child.extensions.map(extension =>
          Object.assign(extension, {
            target: getId(extension.target)
          })
        );
        child.source.derive = child.source.derive.map(getId);
      }
      return cloneId;
    });
  },

  nextListRemove(next, node) {
    if (!node) return;

    if (node.type === 'split') {
      node.left.forEach(next);
      node.right.forEach(next);
    } else if (node.type === 'map' && node.state)
      node.state.forEach(key => {
        next(key);
        next(toMapId(key));
      });
    else if (node.type === 'list' && node.state) node.state.forEach(next);
    else if (node.type === 'union') node.options.forEach(next);
    else if (node.type === 'record') node.fields.forEach(next);
  },

  getSplitNode(data, key, stateIfList = false) {
    const node = has$2(data, key) && data[key];
    if (!node) return null;

    if (node.type === 'list' || node.type === 'map') {
      node.split = stateIfList;
      return null;
    }

    return node;
  }
};

const addListOrMap = (uid, { source, target, emptyOnly, collapsed }, store) => {
  const childId = new KeyChain(source).push(uid());
  const childKey = childId.join();
  const substore = has$2(store.data, source) && store.data[source];
  if (!substore || (substore.type !== 'map' && substore.type !== 'list')) return store; // Add Child to Node

  if (substore.state == null) substore.state = []; // check emptyOnly condition when the list/map is not empty

  if (emptyOnly && substore.state.length > 0) {
    return store;
  }

  substore.visible = !collapsed;
  const state = substore.state;
  state.push(childKey); // In case of map

  if (substore.type === 'map') {
    const mapKey = toMapId(childKey);
    const mapNode = makeValue({
      label: '',
      nullable: false
    });
    store.data[mapKey] = mapNode;
    mapNode.state = target || '';
  } // Create Child Node

  helpers$7
    .nextListAdd(store, substore.base, collapsed, x => childId.replace(x, BASE_ID$1)) // Hook derives
    .forEach(source =>
      extend.init(
        {
          source
        },
        store
      )
    );
  return store;
};

const removeListOrMap = ({ source, target: childId }, store) => {
  const substore = has$2(store.data, source) && store.data[source];
  if (!substore || (substore.type !== 'list' && substore.type !== 'map') || !substore.state) return store; // Remove Child from Node

  for (let i = 0; i < substore.state.length; i++)
    if (substore.state[i] === childId) {
      substore.state.splice(i, 1);
      break;
    } // Remove Store Nodes

  const stack = substore.type === 'map' ? [childId, toMapId(childId)] : [childId];
  const next = helpers$7.nextListRemove.bind(null, x => stack.push(x));

  while (stack.length) {
    const id = stack.pop();
    next(store.data[id]);
    delete store.data[id];
  }

  return store;
};

const addSplit = (uid, { source, left, right }, store) => {
  const substore = helpers$7.getSplitNode(store.data, source, true);
  if (!substore || substore.type !== 'record') return store;
  let fields = new Set(substore.fields);
  left = (left || []).filter(fields.has.bind(fields));
  right = (right || []).filter(fields.has.bind(fields));
  if (!(left.length || right.length)) return store;
  fields = new Set([...left, ...right]);
  const newId = toSplitId(uid, source);
  substore.fields[substore.fields.indexOf(left[0])] = newId;

  for (let i = substore.fields.length; i > 0; ) {
    i--;
    if (fields.has(substore.fields[i])) substore.fields.splice(i, 1);
  }

  store.data[newId] = {
    type: 'split',
    left,
    right,
    enabled: true,
    readOnly: false,
    source
  };
  return store;
};

const removeSplit = ({ source }, store) => {
  const node = helpers$7.getSplitNode(store.data, source);
  if (!node || node.type !== 'split') return store;
  const target = has$2(store.data, node.source) && store.data[node.source];
  if (!target || target.type !== 'record' || !isOf(target.fields, source)) return store;
  target.fields.splice(target.fields.indexOf(source), 1, ...node.left, ...node.right);
  delete store.data[source];
  return store;
};

const expand = {
  list: {
    add: addListOrMap,
    remove: removeListOrMap
  },
  map: {
    add: addListOrMap,
    remove: removeListOrMap
  },
  split: {
    add: addSplit,
    remove: removeSplit
  }
};

expand._helpers = helpers$7;

/**
 * This utility obtains the fields separated by split objects.
 * @param {{[x: string]: StoreNode}} data is the data part of the datamodel.
 * @return {SplitsMap} parent, and its splits.
 */

const extract = data =>
  Object.keys(data)
    .filter(key => data[key].type === 'split')
    .reduce((acc, key) => {
      const base = new KeyChain(key)
        .pop()
        .pop()
        .join();
      if (has$2(acc, base)) acc[base].push(key);
      else acc[base] = [key];
      return acc;
    }, {});
/**
 * This utility obtains the fields that would've been part of a record
 * if not for a split.
 * @param {SplitsMap} splits is a reduced splits map.
 * @param {object} data is the data part of the datamodel.
 * @param {string} key is the key of the record.
 */

const reduce = (splits, data, key) => {
  if (!has$2(data, key)) throw new Error(`Node '${key}' not found.`);
  const node = data[key];
  if (node.type !== 'record') throw new Error(`Node '${key} is not a 'record'.`);
  return !has$2(splits, key)
    ? node.fields
    : splits[key].reduce((acc, split) => {
        /* istanbul ignore if */
        if (!has$2(data, split)) throw new Error(`Node '${split}' not found.`);
        const splitNode = data[split];
        /* istanbul ignore if */

        if (splitNode.type !== 'split') throw new Error(`Node '${split} is not a 'split'.`);
        return [...acc, ...splitNode.left, ...splitNode.right];
      }, node.fields);
};

const extractAndReduce = data => reduce.bind(null, extract(data), data);

const ERRORS = {
  UNION: 'union conflict',
  INVALID: 'invalid field',
  TYPE: 'type mismatch',
  VALUE: 'invalid value'
};
const helpers$8 = {
  mergeRecord(stack, key, model, chain, target) {
    const newChain = chain.push(target);
    const newKey = newChain.join(); // Because Split will move keys around we have to consolidate them here

    const fields = this._splits(key);

    if (!fields.some(x => x === newKey))
      return this.errors.push({
        key: newKey,
        error: ERRORS.INVALID
      });
    return stack.push({
      model: model[target],
      chain: newChain
    });
  },

  mergeUnion(stack, model, chain, base, resolve, target) {
    const newChain = chain.push(target),
      newKey = newChain.join();
    if (!isOf(base.options, newKey))
      return this.errors.push({
        key: newKey,
        error: ERRORS.INVALID
      });

    if (resolve || typeof resolve === 'object') {
      if (resolve === target) base.state = newKey;
    } else if (!base.state) base.state = newKey;
    else
      return this.errors.push({
        key: newKey,
        error: ERRORS.UNION
      });

    return stack.push({
      model: model[target],
      chain: newChain
    });
  },

  mergeEnumSet(stack, chain, key, model) {
    for (const enumVal of model) {
      const enumKey = typeof enumVal === 'string' && chain.push(constToCamel(enumVal)).join(),
        enumNode = enumKey && has$2(this.store.data, enumKey) && this.store.data[enumKey];

      if (!enumNode || enumNode.type !== 'bool') {
        this.errors.push({
          key: enumKey || key,
          error: ERRORS.INVALID
        });
        continue;
      }

      enumNode.state = true;
    }
  },

  mergeList(stack, model, chain, key, base) {
    if (base.type === 'record' && base.unique) return helpers$8.mergeEnumSet.call(this, stack, chain, key, model);
    if (base.type !== 'list')
      return this.errors.push({
        key,
        error: ERRORS.TYPE
      });
    /* istanbul ignore else */

    if (base.state == null) base.state = [];
    const state = base.state;
    return model.forEach(submodel => {
      expand.list.add(
        this.UID,
        {
          source: key,
          collapsed: this.startListsCollapsed
        },
        this.store
      );
      stack.push({
        model: submodel,
        chain: new KeyChain(state[state.length - 1])
      });
    });
  },

  mergeMap(stack, model, key, base) {
    if (base.type !== 'map')
      return this.errors.push({
        key,
        error: ERRORS.TYPE
      });
    /* istanbul ignore else */

    if (base.state == null) base.state = [];
    const state = base.state;
    return Object.keys(model).forEach(target => {
      expand.map.add(
        this.UID,
        {
          source: key,
          target
        },
        this.store
      );
      stack.push({
        model: model[target],
        chain: new KeyChain(state[state.length - 1])
      });
    });
  },

  mergeRecordUnionOrMap(stack, model, chain, key, base) {
    const keys = Object.keys(model).filter(k => !k.startsWith('_'));
    if (!keys.length) return;
    else if (base.type === 'record') {
      base.state = true;
      if (base.unique)
        this.errors.push({
          key,
          error: ERRORS.TYPE
        });
      else keys.forEach(helpers$8.mergeRecord.bind(this, stack, key, model, chain));
    } else if (base.type === 'union') {
      base.state = null;
      keys.forEach(helpers$8.mergeUnion.bind(this, stack, model, chain, base, model._resolves));
    } else helpers$8.mergeMap.call(this, stack, model, key, base);
  },

  mergeValueOrEnum(model, key, base) {
    if ((base.type === 'enum' || base.type === 'value') && typeof model === 'string') base.state = model;
    else if (base.type === 'number' && (typeof model === 'number' || typeof model === 'string')) base.state = model;
    else if (base.type === 'bool' && typeof model === 'boolean') base.state = model;
    else
      this.errors.push({
        key,
        error: ERRORS.TYPE
      });
  },

  execute(stack, model, chain, key) {
    const base = this.store.data[key];
    if (Array.isArray(model)) helpers$8.mergeList.call(this, stack, model, chain, key, base);
    else if (model && typeof model === 'object')
      helpers$8.mergeRecordUnionOrMap.call(this, stack, model, chain, key, base);
    else if (model != null) helpers$8.mergeValueOrEnum.call(this, model, key, base);
  }
};
/**
 * @class
 * The Merger utility class will help merge a payload to the datamodel.
 */

class Merger {
  /**
   * @param {(Merger|MergerOpts)} opts are the settings to initalize this class.
   */
  constructor({ model, UID, startListsCollapsed = false }) {
    this.model = model;
    this.startListsCollapsed = startListsCollapsed;
    this.UID = UID;
    this.errors = [];
  }

  transform(store) {
    if (!this.model) return store;
    this._splits = extractAndReduce(store.data);
    this.store = store;
    this.errors.splice(0, this.errors.length);

    const stack = function() {
      const root = has$2(this.model, store.root) ? this.model[store.root] : this.model;
      return Object.keys(root).map(key => ({
        model: root[key],
        chain: new KeyChain(key)
      }));
    }.call(this);

    while (stack.length) {
      const { model, chain } = stack.pop();
      const key = chain.join();
      /* istanbul ignore if */

      if (!has$2(this.store.data, key)) {
        this.errors.push({
          key,
          error: ERRORS.INVALID
        });
        continue;
      }

      helpers$8.execute.call(this, stack, model, chain, key);
    }

    for (const source in this.store.data)
      mutate.init(
        {
          source
        },
        this.store
      );

    delete this._splits;
    return this.store;
  }
}

Merger.ERROR = ERRORS; // @ts-ignore

Merger._helpers = helpers$8;

var aFunction$1 = function(it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  }
  return it;
};

var sloppyArrayMethod = function(METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return (
    !method ||
    !fails(function() {
      // eslint-disable-next-line no-useless-call,no-throw-literal
      method.call(
        null,
        argument ||
          function() {
            throw 1;
          },
        1
      );
    })
  );
};

var test = [];
var nativeSort = test.sort;

// IE8-
var FAILS_ON_UNDEFINED = fails(function() {
  test.sort(undefined);
});
// V8 bug
var FAILS_ON_NULL = fails(function() {
  test.sort(null);
});
// Old WebKit
var SLOPPY_METHOD = sloppyArrayMethod('sort');

var FORCED = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || SLOPPY_METHOD;

// `Array.prototype.sort` method
// https://tc39.github.io/ecma262/#sec-array.prototype.sort
_export(
  { target: 'Array', proto: true, forced: FORCED },
  {
    sort: function sort(comparefn) {
      return comparefn === undefined
        ? nativeSort.call(toObject(this))
        : nativeSort.call(toObject(this), aFunction$1(comparefn));
    }
  }
);

const helpers$9 = {
  /**
   * Private function to create an easy to traverse tree of all fields given.
   * @param {string[]} fields are the fields to create a tree of
   * @return {Object} an object whose values are other objects, what matters is
   * how the keys are arranged.
   */
  restructureFields() {
    const cache = {
      __root__: {}
    };
    [...this.fields].sort().forEach(key => {
      if (has$2(cache, key)) return;
      const chain = new KeyChain(key);
      const clone = chain.copy(); // Roll back to nearest cached level

      while (chain.length && !has$2(cache, chain.join())) chain.chain.pop();

      let model = !chain.length ? cache['__root__'] : cache[chain.join()];

      while (chain.length !== clone.length) {
        // Grow back to full chain
        chain.chain.push(clone.chain[chain.length]); // Cache, expand model, and move up one level.

        model = model[chain.key] = cache[chain.join()] = {};
      }
    });
    return cache['__root__'];
  },

  /**
   * Private utility function to add tasks to stack for Records|Splits|Unions
   * @param {ExporterStack[]} stack is the list of steps to take.
   * @param {KeyChain} chain is the key of the current level
   * @param {object} model is the reduced key mappings
   * @param {object} store is the exported model current level.
   * @param {boolean} enabled if the field is active
   * @param {addToStackTest} test if the next level should be added to the stack.
   * @param {string} nextKey is the next level key
   */
  addFromRecordToStack(stack, chain, model, store, enabled, test, nextKey) {
    const nextChain = chain.push(nextKey);
    test(nextChain) &&
      stack.push({
        chain: nextChain,
        model: model[nextKey],
        enabled,
        store
      });
  },

  /**
   * Private utility function to add tasks to stack for Records|Splits|Unions
   * @param {ExporterStack[]} stack is the list of steps to take.
   * @param {KeyChain} chain is the key of the current level
   * @param {ExporterModel} model is the reduced key mappings
   * @param {{[x: string]: any}} store is the exported model current level.
   * @param {boolean} enabled if the field is active
   * @param {(ListNode|MapNode)} state is the list of valid fields
   * @param {string?} mask is alternative name of the item
   * @param {string} nextKey is the next level key
   */
  addFromListToStack(stack, chain, model, store, enabled, node) {
    return (mask, nextKey) => {
      /* istanbul ignore if */
      if (!nextKey) return 1;
      const nextChain = chain.push(nextKey);
      const index = (
        node.state ||
        /* istanbul ignore next */
        []
      ).indexOf(nextChain.join());
      let safeMask = `${index}`;

      if (node.type === 'map') {
        const nextMapKey = toMapId(nextChain);
        /* istanbul ignore if */

        if (!has$2(this._data, nextMapKey)) return 2;
        const mapNode = this._data[nextMapKey];
        /* istanbul ignore if */

        if (mapNode.type !== 'value') return 3;
        safeMask = mapNode.state;
        /* istanbul ignore if */

        if (!safeMask) return 4;
      }

      index !== -1 &&
        stack.push({
          chain: nextChain,
          model: model[nextKey],
          enabled,
          // $FlowFixMe
          store,
          mask: mask || safeMask
        });
      return 0;
    };
  },

  exportEnumSet(base, { store, key, mask }) {
    /* istanbul ignore if */
    if (!(this.simple || base.state)) return; // Because Split will move keys around we have to consolidate them here

    const nextStore = this._splits(key)
      .map(nextKey => {
        const nextNode = has$2(this._data, nextKey) && this._data[nextKey];
        /* istanbul ignore if */

        if (!nextNode || nextNode.type !== 'bool' || !nextNode.state) return null;
        return camelToConst(new KeyChain(nextKey).key);
      })
      .filter(Boolean);
    /* istanbul ignore else */

    if (this.simple || !base.nullable || nextStore.length) store[mask] = nextStore;
  },

  exportRecord(base, { stack, chain, model, store, key, enabled, mask, keys }) {
    /* istanbul ignore if */
    if ((!keys.length && base.nullable) || (!base.state && !this.simple)) return;
    const nextStore = {};
    store[mask] = nextStore; // Because Split will move keys around we have to consolidate them here

    const test = function() {
      const fn = staticIsOf(this._splits(key));
      return c => fn(c.join());
    }.call(this);

    keys.forEach(helpers$9.addFromRecordToStack.bind(this, stack, chain, model, nextStore, enabled, test));
  },

  exportListOrMap(base, { stack, chain, model, store, enabled, mask, keys }) {
    /* istanbul ignore if */
    if (base.nullable && (!keys.length || !base.state)) return;
    let nextStore = store;
    if (!this.simple)
      nextStore = store[mask] =
        base.type === 'map'
          ? /* istanbul ignore next */
            {}
          : []; // Case where arrays and map are discouraged like derive

    const addStackFromList = helpers$9.addFromListToStack.call(this, stack, chain, model, nextStore, enabled, base);
    this.simple ? addStackFromList.call(this, mask, keys[0]) : keys.forEach(addStackFromList.bind(this, undefined));
  },

  exportUnion(base, { stack, chain, model, store, enabled, mask, keys }) {
    /* istanbul ignore if */
    if (!keys.length || (!this.simple && !base.state)) return;
    const nextStore = {};
    store[mask] = nextStore;

    const test = nextChain => nextChain.join() === base.state;

    keys.forEach(helpers$9.addFromRecordToStack.bind(this, stack, chain, model, nextStore, enabled, test));
  },

  exportEnum(base, { store, enabled, mask }) {
    if (base.state == null || (this.simple && !enabled)) {
      store[mask] = null;
      return;
    }

    if (base.nullable && base.state === '') {
      store[mask] = null;
      return;
    }

    store[mask] = base.state;
  },

  exportValue(base, { store, enabled, mask }) {
    if (base.state == null || (this.simple && !enabled)) {
      store[mask] = null;
      return;
    }

    switch (base.type) {
      case 'value':
      case 'bool':
        store[mask] = base.state;
        break;

      case 'number':
        store[mask] = isNaN(+base.state) ? base.state : +base.state;
    }
  },

  execute(base, opts) {
    /* istanbul ignore if */
    if (base.type === 'split') return;
    if (opts.enabled == null || opts.enabled) opts.enabled = has$2(base, 'enabled') ? base.enabled : true;
    /* istanbul ignore if */

    if (!opts.enabled && !this.simple) return;

    if (base.type === 'record') {
      if (base.unique) helpers$9.exportEnumSet.call(this, base, opts);
      else helpers$9.exportRecord.call(this, base, opts);
    } else if (base.type === 'map' || base.type === 'list') helpers$9.exportListOrMap.call(this, base, opts);
    else if (base.type === 'union') helpers$9.exportUnion.call(this, base, opts);
    else if (base.type === 'enum') helpers$9.exportEnum.call(this, base, opts);
    else helpers$9.exportValue.call(this, base, opts);
  }
};
class Exporter {
  /**
   * The Exporter is a utility class that converts the store into a plain object.
   * @param {(ExporterOpts|Exporter)} opts are the options to initialize the transformer.
   */
  constructor(
    { fields = [], simple = true, internal = false } = {
      fields: undefined
    }
  ) {
    this.simple = simple;
    this.fields = fields;
    this.internal = internal;
  }
  /**
   * The transform method converts the datamodel into a payload for BBDS.
   * @param {Store} store is the datamodel.
   * @returns {ExporterModel} is the json payoad.
   */

  transform(store) {
    this._data = store.data;
    this._fields = helpers$9.restructureFields.call(this);
    this._splits = extractAndReduce(store.data);
    this.store = {};
    /* istanbul ignore else */

    if (!this.simple && !this.store[store.root]) this.store[store.root] = {};
    const stack = Object.keys(this._fields).map(key => ({
      chain: new KeyChain(key),
      model: this._fields[key],
      store: !this.simple
        ? this.store[store.root]
        : /* istanbul ignore next */
          this.store // mask: null, array index or map key
    }));

    while (stack.length) {
      const { chain, model, store, enabled = null, mask = null } = stack.pop();
      const key = chain.join();
      /* istanbul ignore if */

      if (!has$2(this._data, key)) continue;
      helpers$9.execute.call(this, this._data[key], {
        stack,
        chain,
        model,
        store,
        key,
        enabled,
        mask:
          mask == null
            ? chain.key
            : /* istanbul ignore next */
              mask,
        keys: Object.keys(model)
      });
    }

    delete this._data;
    delete this._fields;
    delete this._splits;
    return this.store;
  }
} // @ts-ignore

Exporter._helpers = helpers$9;

const normalize$1 = key => new KeyChain(key).join();

const helpers$a = {
  makeReplaceFn(chain) {
    return produce(draft => {
      // @ts-ignore
      draft.source = chain.startReplace(draft.source, BASE_ID$1, true);
      /* istanbul ignore else */

      if (has$2(draft, 'target')) {
        // @ts-ignore
        const target = draft.target; // @ts-ignore

        /* istanbul ignore else */

        if (target) draft.target = chain.startReplace(target, BASE_ID$1);

        if (has$2(draft, 'lookup')) {
          // @ts-ignore
          const lookup = draft.lookup; // @ts-ignore

          /* istanbul ignore else */

          if (lookup) draft.lookup = chain.startReplace(lookup, BASE_ID$1);
        }

        if (has$2(draft, 'ref')) {
          // @ts-ignore
          const ref = draft.ref; // @ts-ignore

          /* istanbul ignore else */

          if (ref) draft.ref = chain.startReplace(ref, BASE_ID$1);
        }
      } else if (draft.type === 'expand.split.add') {
        const replace = (val, idx, arr) => (arr[idx] = chain.startReplace(val, BASE_ID$1));

        draft.left && draft.left.forEach(replace);
        draft.right && draft.right.forEach(replace);
      }

      return draft;
    });
  },

  genReplace: function*({ avro, root }, actions, target) {
    const replace = helpers$a.makeReplaceFn(new KeyChain(target));

    for (const draft of actions) {
      if (draft.type === 'reference.type') {
        yield* helpers$a.genDerefencedActions(
          {
            avro,
            root,
            offset: target
          },
          [draft]
        );
        continue;
      }

      const action = replace(draft);
      if (action.type === 'reference.path')
        yield* helpers$a.genDerefencedActions(
          {
            avro
          },
          [action]
        );
      else yield action;
    }
  },
  genDerefencedActions: function*({ avro, root, offset }, actions) {
    for (const action of actions) {
      if (action.type === 'reference.type') {
        /* istanbul ignore else */
        if (avro)
          for (const target of avro.getPathsForType(action.source, root, offset))
            yield* helpers$a.genReplace(
              {
                avro,
                root: action.source
              },
              action.actions,
              target
            );
      } else if (action.type === 'reference.path')
        yield* helpers$a.genReplace(
          {
            avro
          },
          action.actions,
          new KeyChain(action.source).keys
        );
      else yield action;
    }
  }
};
/**
 * @class
 * The Mutator utility class simply lumps mutators together.
 */

class Mutator {
  /**
   * @param {(Mutator|MutatorOpts)} opts are the settings to initalize this class.
   */
  constructor({ actions, UID }) {
    this.actions = actions;
    this.UID = UID;
  }

  transform(store) {
    if (!this.actions || !this.actions.length) return store;
    this.store = store;

    for (const action of this.actions) {
      const dotIndex = action.type.indexOf('.'),
        type = action.type.substring(0, dotIndex),
        executor = {
          expand: this.expand,
          extend: this.extend,
          mutate: this.mutate
        }[type];
      /* istanbul ignore else */

      if (executor)
        this.store = executor.call(this, {
          action
        });
    }

    return this.store;
  }

  expand({ action, UID }, store) {
    store = store || this.store;
    UID = UID || this.UID;
    if (!UID && action.type.endsWith('add')) return store;
    if (action.type === 'expand.list.add')
      expand.list.add(
        UID,
        {
          source: normalize$1(action.source),
          target: action.target && normalize$1(action.target),
          emptyOnly: action.emptyOnly
        },
        store
      );
    else if (action.type === 'expand.list.remove')
      expand.list.remove(
        {
          source: normalize$1(action.source),
          target: normalize$1(action.target)
        },
        store
      );
    else if (action.type === 'expand.map.add')
      expand.map.add(
        UID,
        {
          source: normalize$1(action.source),
          target: action.target && normalize$1(action.target),
          emptyOnly: action.emptyOnly
        },
        store
      );
    else if (action.type === 'expand.map.remove')
      expand.map.remove(
        {
          source: normalize$1(action.source),
          target: normalize$1(action.target)
        },
        store
      );
    else if (action.type === 'expand.split.add')
      expand.split.add(
        UID,
        {
          source: normalize$1(action.source),
          left: action.left && action.left.map(normalize$1),
          right: action.right && action.right.map(normalize$1)
        },
        store
      );
    else if (action.type === 'expand.split.remove')
      expand.split.remove(
        {
          source: normalize$1(action.source)
        },
        store
      );
    return store;
  }

  extend({ action }, store) {
    store = store || this.store;
    if (action.type === 'extend.clone')
      extend.clone(
        {
          source: normalize$1(action.source),
          target: normalize$1(action.target)
        },
        store
      );
    else if (action.type === 'extend.clone.enabled')
      extend.clone.enabled(
        {
          source: normalize$1(action.source),
          target: action.target && normalize$1(action.target),
          pattern: action.pattern,
          not: action.not
        },
        store
      );
    else if (action.type === 'extend.reset') {
      extend.reset(
        {
          source: normalize$1(action.source),
          target: normalize$1(action.target)
        },
        store
      );
    } else if (action.type === 'extend.copy') {
      // @ts-ignore
      extend.copy(
        {
          source: normalize$1(action.source),
          target: action.target && normalize$1(action.target),
          pattern: action.pattern,
          not: action.not,
          lookup: normalize$1(action.lookup || action.source),
          key: action.key
        },
        store
      );
    } else if (action.type === 'extend.readOnly') {
      // @ts-ignore
      extend.readOnly(
        {
          source: normalize$1(action.source),
          target: action.target && normalize$1(action.target),
          pattern: action.pattern,
          not: action.not
        },
        store
      );
    } else if (action.type === 'extend.setLabel') {
      extend.setLabel(
        {
          source: normalize$1(action.source),
          target: action.target && normalize$1(action.target),
          lookup: action.lookup && normalize$1(action.lookup),
          pattern: action.pattern,
          not: action.not,
          rule: action.rule,
          value: action.value,
          replace: action.replace
        },
        store
      );
    } else if (action.type === 'extend.setValue')
      extend.setValue(
        {
          source: normalize$1(action.source),
          target: action.target && normalize$1(action.target),
          pattern: action.pattern,
          not: action.not,
          rule: action.rule,
          key: action.key,
          value: action.value
        },
        store
      );
    else if (action.type === 'extend.derive')
      extend.derive(
        {
          source: normalize$1(action.source)
        },
        store
      );
    else if (action.type === 'extend.require')
      extend.require(
        {
          source: normalize$1(action.source),
          target: action.target && normalize$1(action.target),
          pattern: action.pattern,
          not: action.not
        },
        store
      );
    else if (action.type === 'extend.display')
      extend.display(
        {
          source: normalize$1(action.source),
          target: action.target && normalize$1(action.target),
          pattern: action.pattern,
          not: action.not
        },
        store
      );
    else if (action.type === 'extend.show') {
      extend.show(
        {
          source: normalize$1(action.source),
          target: action.target && normalize$1(action.target),
          pattern: action.pattern,
          ref: action.ref,
          not: action.not
        },
        store
      );
    }
    return store;
  }

  mutate({ action }, store) {
    store = store || this.store;
    if (action.type === 'mutate.clone.enabled')
      mutate.clone.enabled(
        {
          source: normalize$1(action.source),
          value: action.value
        },
        store
      );
    else if (action.type === 'mutate.setLabel') {
      mutate.setLabel(
        {
          source: normalize$1(action.source),
          rule: action.rule,
          value: action.value
        },
        store
      );
    } else if (action.type === 'mutate.setValue') {
      mutate.setValue(
        {
          source: normalize$1(action.source),
          rule: action.rule,
          key: action.key,
          value: action.value
        },
        store
      );
    } else if (action.type === 'mutate.display')
      // @ts-ignore
      mutate.display(
        {
          source: normalize$1(action.source),
          value: action.value
        },
        store
      );
    else if (action.type === 'mutate.show') {
      // @ts-ignore
      mutate.display(
        {
          source: normalize$1(action.source),
          value: action.value
        },
        store
      );
    } else if (action.type === 'mutate.collapse')
      mutate.collapse(
        {
          source: normalize$1(action.source),
          value: action.value
        },
        store
      );
    else if (action.type === 'mutate.readOnly') {
      // @ts-ignore
      mutate.readOnly(
        {
          source: normalize$1(action.source),
          value: action.value
        },
        store
      );
    } else if (action.type === 'mutate.require')
      // @ts-ignore
      mutate.require(
        {
          source: normalize$1(action.source),
          value: action.value
        },
        store
      );
    else if (action.type === 'mutate.unique')
      mutate.unique(
        {
          source: normalize$1(action.source),
          value: action.value
        },
        store
      );
    return store;
  }

  static dereferenceActions(avro, actions) {
    /* istanbul ignore else */
    if (avro && !(avro instanceof Avro)) avro = new Avro(avro.schema, avro); // @ts-ignore

    const newActions = [
      ...helpers$a.genDerefencedActions(
        {
          avro
        },
        actions
      )
    ];
    /*:: ((newActions:any):MutatorNode[])*/

    return newActions;
  }
} // @ts-ignore

Mutator._helpers = helpers$a;

const isnan = n => !n || isNaN(n);

const helpers$b = {
  validate(node, state) {
    return this.rules
      .map(({ test, message, apply }) => {
        /* istanbul ignore if */
        if (Array.isArray(apply)) apply = isOf.bind(null, apply);

        if (node.min !== undefined && node.min !== null && node.max !== undefined && node.max !== null) {
          if (node.type == 'number') message = 'This field must have value between ' + node.min + '-' + node.max + '.';
          else if (node.type == 'value')
            message = 'This field must have length between ' + node.min + '-' + node.max + '.';
        }

        return apply(node.type) && test(node, state) ? message : null;
      })
      .filter(Boolean);
  },

  collectIterableErrors(keys, errors, state, key) {
    /* istanbul ignore else */
    if (state != null) {
      if (keys.has(state)) {
        errors = [].concat(errors).concat('This field is not unique');
      } else keys.add(state);
    }

    errors = errors.length > 1 ? errors : errors[0];
    /* istanbul ignore if */

    if (!errors) return;

    if (has$2(this.store, key) && this.store[key]) {
      this.store[key] = [].concat(this.store[key]).concat(errors);
    } else this.store[key] = errors;
  },

  /**
   * Meant to validate sets which have unique 2-level validations
   * @param {SetNode} node
   */
  validateSetNode(node, child, collectErrors) {
    const setKey =
      typeof node.unique === 'string' ? new KeyChain(child).startReplace(node.unique, KeyChain.BASE_ID, true) : child;
    /* istanbul ignore if */

    if (!has$2(this._data, setKey)) return;
    const setNode = ifValue(this._data[setKey]);
    /* istanbul ignore if */

    if (!setNode || setNode.type === 'bool') return;
    collectErrors.call(this, [], setNode.state, setKey);
  },

  /**
   * Meant to validate maps which have unique 2-level validations
   * @param {MapNode} node
   */
  validateMapNode(node, child, collectErrors) {
    const mapKey = toMapId(child);
    /* istanbul ignore if */

    if (!has$2(this._data, mapKey)) return;
    const mapNode = this._data[mapKey];
    /* istanbul ignore if */

    if (mapNode.type !== 'value') return;
    const state = mapNode.state;
    collectErrors.call(this, helpers$b.validate.call(this, mapNode, state), state, mapKey);
  },

  applyIterable: function applyIterable(node, validateNode) {
    const children = node.state || [];
    const keys = new Set();

    for (const child of children)
      validateNode.call(this, node, child, helpers$b.collectIterableErrors.bind(this, keys));

    return '';
  },

  /**
   * The _apply method saves an error in a per-field level.
   * NOTE: This is an internal function.
   * @param {string} error is the error message
   * @param {string} key is the key of the datamodel field.
   */
  apply(error, key) {
    const node = ifTestable(this._data[key]);
    /* istanbul ignore if */

    if (!node || node.type === 'list' || node.type === 'map') return;
    node.error = error || '';
  },

  execute(key, node, next) {
    switch (node.type) {
      case 'split':
        node.left.forEach(next);
        node.right.forEach(next);
        break;

      case 'record':
        node.fields.forEach(next);
        break;

      case 'list':
      case 'map':
        this.validate({
          source: key
        });
        /* istanbul ignore else */

        if (node.state) node.state.forEach(next);
        break;

      case 'union':
        this.validate({
          source: key
        });
        /* istanbul ignore else */

        if (node.state) next(node.state);
        break;

      default:
        this.validate({
          source: key
        });
    }
  }
};
/**
 * @class
 */

class Validator {
  /**
   * The Validator will analyze a store for all rules.
   * @param {(Validator|ValidatorOpts)} opts are the options needed to initiate the Validator
   */
  constructor({ fast = false, seed = ['data'], global = false, codes = {} } = {}) {
    this.seed = seed;
    this.fast = fast;
    this.global = global;
    this.codes = codes;
    this.rules = [...Validator.RULES];
  }
  /**
   * The transform method will convert the store to errors given specified
   * options.
   * @param {Store} store is the datamodel
   * @return {Store}
   */

  transform(store) {
    this._data = store.data;
    this.store = {};
    const stack = [...this.seed];

    const next = x => stack.push(x);

    while (stack.length && !(this.fast && Object.keys(this.store).length)) {
      const key = stack.pop();
      /* istanbul ignore if */

      if (!has$2(this._data, key)) continue;
      const node = this._data[key];
      /* istanbul ignore if */

      if (!node.enabled || (node.type === 'record' && !node.state)) continue;
      helpers$b.execute.call(this, key, node, next);
    }

    this.pass = !Object.keys(this.store).length;
    delete this._data;
    return this.store;
  }
  /**
   * The validate method will verify errors at a per-field level.
   * @param {ValidatorParams} params are the options of this method.
   * @param {Store} store is the datamodel
   */

  validate({ source }, store) {
    this._data = (store && store.data) || this._data;
    /* istanbul ignore if */

    if (!this._data || !has$2(this._data, source)) return '';
    const node = ifTestable(this._data[source]);
    if (!node) return '';
    else if (!this.store) this.store = {};
    if (node.type === 'map') return helpers$b.applyIterable.call(this, node, helpers$b.validateMapNode);
    else if (node.type === 'list') return helpers$b.applyIterable.call(this, node, helpers$b.validateSetNode);
    let errors = helpers$b.validate.call(this, node, node.state);
    errors = errors.length > 1 ? errors : errors[0] || '';
    if (errors) this.store[source] = errors;
    /* istanbul ignore else */

    if (store) delete this._data;
    return errors;
  }
  /**
   * The apply method gets the errors of this validator and saves
   * them in the datamodel.
   * @param {Store} store is the datamodel
   * @return {Store}
   */

  apply(store) {
    this._data = store.data;
    /* istanbul ignore if */

    if (!this.store) return store;
    (this.global
      ? Object.keys(this._data)
      : /* istanbul ignore next */
        this.seed
    ).forEach(helpers$b.apply.bind(this, null));

    for (const errorKey in this.store)
      []
        .concat(has$2(this.codes, errorKey) ? this.codes[errorKey] : errorKey)
        .forEach(helpers$b.apply.bind(this, this.store[errorKey]));

    delete this._data;
    return store;
  }
}
Validator.RULES = [
  {
    // Required
    test: (node, state) => !(node.nullable || state != null),
    message: 'This field is required.',
    apply: ['bool']
  },
  {
    // Required
    test: (node, state) => !(node.nullable || state),
    message: 'This field is required.',
    apply: ['value', 'enum', 'union']
  },
  {
    // Date
    test: (node, state) => !(node.format !== 'date' || !state || new RegExp(node.pattern).test(`${state}`)),
    message: 'This field has an invalid value. Expected format is: yyyy-mm-dd',
    apply: ['value']
  },
  {
    // Datetime
    test: (node, state) => !(node.format !== 'datetime' || !state || new RegExp(node.pattern).test(`${state}`)),
    message: 'This field has an invalid value. Expected format is: yyyy-mm-dd or yyyy-mm-dd HH:MM:SS',
    apply: ['value']
  },
  {
    // Number
    test: (_, state) => isNaN(state),
    message: 'This field is not a number.',
    apply: ['number']
  },
  {
    // Required for number
    test: (node, state) => !(node.nullable || (state !== undefined && state !== null && state !== '')),
    message: 'This field is required.',
    apply: ['number']
  },
  {
    // Max
    test: (node, state) => !(node.max == null || isNaN(state) || node.max >= +state),
    message: 'This field is too high.',
    apply: ['number']
  },
  {
    // Min
    test: (node, state) => !(node.min == null || isNaN(state) || node.min <= +state),
    message: 'This field is too low.',
    apply: ['number']
  },
  {
    // Double
    test: (node, state) => !(node.double || isnan(state) || Math.round(+state) === +state),
    message: 'This field cannot have decimals.',
    apply: ['number']
  },
  {
    // max Length
    test: (node, state) => !(!state || !node.maxLength || state.length <= node.maxLength),
    message: 'This field is too long.',
    apply: ['value']
  },
  {
    // min Length
    test: (node, state) => !(!state || !node.min || state.length >= node.min),
    message: 'This field is too short.',
    apply: ['value']
  },
  {
    // Pattern
    test: (node, state) =>
      !(
        node.format === 'date' ||
        node.format === 'datetime' ||
        !node.pattern ||
        !state ||
        new RegExp(node.pattern).test(`${state}`)
      ),
    message: 'This field has an invalid value.',
    apply: ['value', 'number']
  }
].map(rule => {
  /* istanbul ignore else */
  if (Array.isArray(rule.apply)) {
    // @ts-ignore
    rule.apply = staticIsOf(rule.apply);
  }

  return Object.freeze(rule);
}); // @ts-ignore

Validator._helpers = helpers$b;

var index$1 = /*#__PURE__*/ Object.freeze({
  __proto__: null,
  Deriver: Deriver,
  Grapher: Grapher,
  Merger: Merger,
  Exporter: Exporter,
  Mutator: Mutator,
  Validator: Validator
});

var uid$1 = () => {
  const fn = () => {
    --fn._;
    return fn._;
  };

  fn._ = 0;
  return fn;
};

function _Builder(records, root, opts = {}) {
  // @ts-ignore
  return new Builder(
    _objectSpread2(
      {
        schema: records,
        root
      },
      opts
    ),
    opts
  );
}

var index$2 = /*#__PURE__*/ Object.freeze({
  __proto__: null,
  Builder: _Builder,
  KeyChain: KeyChain
});

var index$3 = /*#__PURE__*/ Object.freeze({
  __proto__: null,
  expand: expand,
  extend: extend,
  mutate: mutate
});

const jquery = (function() {
  let lib = $;
  return {
    get: () => lib || $,
    set: jq => {
      lib = jq;
      return lib;
    }
  };
})();
var externals = {
  jquery,

  hasTooltips() {
    const lib = jquery.get(); // @ts-ignore

    return !!lib && !!lib().tooltip;
  }
};

const TYPE$1 = 'view:collapse:expand';
/**
 * This action type makes all collapsed fields visible again.
 */

const expandCollapsible = () => ({
  type: TYPE$1
});
var ExpandCollapsible = {
  type: TYPE$1,

  handler(state) {
    for (const node of Object.values(state.data)) {
      if ('visible' in node) node.visible = true;
    }

    return state;
  }
};

const TYPE$2 = 'state:init:toggle';
const markInit = id => ({
  type: TYPE$2,
  id
});
var MarkInit = {
  type: TYPE$2,

  handler(state, action) {
    // @ts-ignore
    const node = state.data[action.id];
    node.init = true;
    return state;
  }
};

const TYPE$3 = 'view:mode:push';
var PushMode = {
  type: TYPE$3,

  handler(state, action) {
    if (action.value in Store.EMode) state.mode = action.value;
    return state;
  }
};

const canEdit = (store, id) => {
  if (typeof store === 'function') store = store();
  return store.mode === Store.EMode.EDIT && (id == null || has$2(store.data, id));
};
const validate = (state, action = {}) => {
  const global = !action.source;
  const vT = new Validator({
    global,
    seed: action.source ? [action.source] : state.opts.seed
  });
  vT.transform(state);
  vT.apply(state);
  return vT;
};

const TYPE$4 = 'state:list:reorder';
/**
 * This action will add a child to the array.
 *
 * @param {string} id The string keyChain of the object
 * @param {number} from The index of the element to move
 * @param {number} to The index the element is moving to
 */

const reorderArray = (id, from, to) => ({
  type: TYPE$4,
  id,
  from,
  to
});
var ReorderArray = {
  type: TYPE$4,

  handler(state, action) {
    if (!canEdit(state)) return state;
    mutate.reorder(
      {
        source: action.id,
        to: action.to,
        from: action.from
      },
      state
    );
    return state;
  }
};

const TYPE$5 = 'state:lock:toggle';
/**
 * This action type takes the lock status of the form.
 */

const toggleLock = (value = null) => ({
  type: TYPE$5,
  value
});
var ToggleLock = {
  type: TYPE$5,

  handler(state, action) {
    if (state.mode === Store.EMode.VIEW) return null;
    if (action.value != null) state.mode = action.value ? Store.EMode.LOCK : Store.EMode.EDIT;
    else if (state.mode === Store.EMode.EDIT) state.mode = Store.EMode.LOCK;
    else state.mode = Store.EMode.EDIT;
    return state;
  }
};

const TYPE$6 = 'state:lock:visible';
/**
 * This action type takes the lock status of the form.
 */

const toggleVisible = (id, value = null) => ({
  type: TYPE$6,
  id,
  value
});
var ToggleVisible = {
  type: TYPE$6,

  handler(state, action) {
    // @ts-ignore
    const node = state.data[action.id];
    node.visible = action.value == null ? !node.visible : !!action.value;
    return state;
  }
};

const TYPE$7 = {
  OPTM: 'graph:queue:optim',
  DATA: 'graph:queue:push',
  DEBN: 'graph:queue:dispatch'
};
const queueAction = (field, data = null) => ({
  type: TYPE$7.DATA,
  field,
  data
});
const QueueAction = {
  type: TYPE$7.DATA,

  handler(state, action) {
    const queue = state.tmp[action.field];
    if (action.data)
      // @ts-ignore
      queue.push(action.data);
    else queue.splice(0);
    return state;
  }
};
const optimizeAction = field => ({
  type: TYPE$7.OPTM,
  field
});
const OptimizeAction = {
  type: TYPE$7.OPTM,

  handler(state, action) {
    if (
      action.field === 'notify'
      /* NOTIFY */
    ) {
      state.tmp[action.field] = state.tmp[action.field].filter((v, i, a) => a.indexOf(v) === i);
    } else if (
      action.field === 'validate'
      /* VALIDATE */
    ) {
      state.tmp[action.field] = [
        {
          seed: state.opts.seed,
          report: state.tmp[action.field].some(({ report }) => report)
        }
      ];
    } else Grapher.optimize(state.tmp[action.field]);

    return state;
  }
};
const debounceAction = (field, callback = null) => ({
  type: TYPE$7.DEBN,
  field,
  callback
});
const DebounceAction = {
  type: TYPE$7.DEBN,

  handler(state, action) {
    clearTimeout(state.tmp.debounce[action.field]);

    if (action.callback) {
      // @ts-ignore: Duplicate definition
      state.tmp.debounce[action.field] = setTimeout(action.callback, state.opts[action.field].debounce || 150);
    }

    return state;
  }
};
var QueueAction$1 = [QueueAction, OptimizeAction, DebounceAction];

const TYPE$8 = 'state:autocomplete',
  QUEUE_TYPE = 'autocomplete';
  /* AUTOCOMPLETE */
/**
 * This action type takes the element of which
 * its state should be modified.
 *
 * @param {string} id The string keyChain of the object
 * @param {*} state The flat extension object
 * @param {*} filter If the object is to be filtered
 */

const action = (id, value, filter = false) => ({
  type: TYPE$8,
  id,
  value,
  filter
});

const SEPARATOR_REGEX = new RegExp(KeyChain.escape(KeyChain.DEFAULT_SEPARATOR), 'g');

const filteredKey = id => `bbds-form-${id.replace(SEPARATOR_REGEX, '-')}`;

const unfilteredKey = (id, state) => `${filteredKey(id)}-value-${state}`;

const makeCallback = (target, data, store, cacheSet, dispatch) => extensions => {
  if (!extensions) return;
  new Deriver({
    type: AUC_TYPE,
    fields: target,
    extensions,

    callback(id, state) {
      const filter = state.type.client.filter;
      cacheSet(filter ? filteredKey(id) : unfilteredKey(id, data[id]), state);
      dispatch(action(id, state, filter));
    }
  }).transform(store);
};
/**
 * This action type distributes the derive calls to server
 *
 * Uses: Redux-Thunk
 */

const autocompleteState = id => (dispatch, getState) => {
  const store = getState();
  const { cacheGet, cacheSet, onAutocomplete } = store.opts.callbacks;
  dispatch(
    queueAction(QUEUE_TYPE, {
      source: [],
      target: [id],
      next: {}
    })
  );
  dispatch(
    debounceAction(QUEUE_TYPE, () => {
      dispatch(optimizeAction(QUEUE_TYPE));
      const store = getState();
      store.tmp.autocomplete.forEach(({ target }) => {
        const data = {};
        target = target.filter(id => {
          // @ts-ignore
          const node = store.data[id];
          const filter = node.autocomplete.filter,
            dataVal = node.state,
            cacheKey = filter ? filteredKey(id) : unfilteredKey(id, dataVal),
            cacheVal = cacheGet(cacheKey);
          data[id] = dataVal;
          if (!cacheVal) return true;
          dispatch(action(id, cacheVal, filter));
          return false;
        });
        if (!target.length) return;
        const model = new Exporter({
          fields: target
        }).transform(store);
        onAutocomplete(target, model, makeCallback(target, data, store, cacheSet, dispatch));
      }); // Clear

      dispatch(queueAction(QUEUE_TYPE));
    })
  );
};
var AutoCompleteState = {
  type: TYPE$8,

  handler(store, action) {
    if (!canEdit(store) || !action.value || !action.value.enum) return store; // @ts-ignore: enforce node type elsewhere

    const node = store.data[action.id],
      auc = node.autocomplete,
      re = node.state && new RegExp(KeyChain.escape(node.state), 'i');
    auc.filter = action.filter;

    if (!action.filter) {
      // @ts-ignore: type handled elsewhere
      auc.options = [...action.value.enum];
      return store;
    }

    auc.options = [];
    action.value.enum.some(x => {
      if (auc.options.length > store.opts.autocomplete.maxResults) return true;
      else if (action.value && (re.test(x.code) || re.test(x.display))) return false;
      auc.options.push(x);
      return false;
    });
    return store;
  }
};

const TYPE$9 = 'state:validate',
  QUEUE_TYPE$1 = 'validate';
  /* VALIDATE */

const action$1 = () => ({
  type: TYPE$9
});

var ValidateState = {
  type: TYPE$9,

  handler(state) {
    const validator = validate(state); // Notify

    if (state.tmp.validate[0].report) state.opts.callbacks.onValidate(validator.pass, validator.store); // Update

    state.valid = validator.pass;
  }
};
/**
 * This action type takes the element of which
 * its state should be modified.
 */

const thunk = () => dispatch => {
  dispatch(debounceAction(QUEUE_TYPE$1));
  dispatch(optimizeAction(QUEUE_TYPE$1)); // Action

  dispatch(action$1()); // Clear

  dispatch(queueAction(QUEUE_TYPE$1));
};
/**
 * This action type distributes the derive calls to server
 */

const validateState = (seed, report = true) => dispatch => {
  dispatch(
    queueAction(QUEUE_TYPE$1, {
      seed,
      report
    })
  );
  dispatch(debounceAction(QUEUE_TYPE$1, () => dispatch(thunk())));
};
/**
 * This action type distributes the derive calls to server
 */

const syncValidateState = (seed, report = true) => dispatch => {
  dispatch(
    queueAction(QUEUE_TYPE$1, {
      seed,
      report
    })
  );
  dispatch(thunk());
};

const TYPE$a = 'state:derive',
  QUEUE_TYPE$2 = 'derive';
  /* DERIVE */

const action$2 = (id, value) => ({
  type: TYPE$a,
  id,
  value
});
/**
 * This action type takes the element of which
 * its state should be modified.
 *
 * NOTE: Uses redux-thunk
 *
 * @param {string} id The string keyChain of the object
 * @param {*} state The flat extension object
 */

const syncDeriveState = (id, value) => (dispatch, getState) => {
  if (!canEdit(getState) || !value || !value.enum) return;
  dispatch(action$2(id, value));
  dispatch(validateState([id], false));
};

const makeCallback$1 = (target, store, dispatch) => extensions => {
  if (!extensions) return;
  new Deriver({
    type: REF_TYPE,
    fields: target,
    extensions,

    callback(id, value) {
      dispatch(syncDeriveState(id, value));
    }
  }).transform(store);
};
/**
 * This action type distributes the derive calls to server
 *
 * Uses: Redux-Thunk
 */

const deriveState = id => (dispatch, getState) => {
  const store = getState();
  const graph = new Grapher({
    fields: [id]
  }).transform(store);
  dispatch(queueAction(QUEUE_TYPE$2, graph));
  dispatch(
    debounceAction(QUEUE_TYPE$2, () => {
      dispatch(optimizeAction(QUEUE_TYPE$2));
      const store = getState();
      store.tmp.derive.forEach(({ source, target }) => {
        const model = new Exporter({
          fields: source
        }).transform(store);
        store.opts.callbacks.onDerive(target, model, makeCallback$1(target, store, dispatch));
      }); // Clear

      dispatch(queueAction(QUEUE_TYPE$2));
    })
  );
};
var DeriveState = {
  type: TYPE$a,

  handler(state, action) {
    // @ts-ignore: enforce node type elsewhere
    const node = state.data[action.id]; // @ts-ignore: type handled elsewhere

    node.options = action.value.enum.map(({ value, description }) => ({
      key: value,
      value: `${description} (${value})`
    }));
    node.enabled = node.options.length > 0;
    if (!node.options.some(({ key }) => node.state === key)) node.state = '';
    return state;
  }
};

const QUEUE_TYPE$3 = 'notify';
  /* NOTIFY */
/**
 * This action type distributes the derive calls to user
 *
 * Uses: Redux-Thunk
 */

var notifyState = id => (dispatch, getState) => {
  const store = getState();
  const { onNotify } = store.opts.callbacks;
  dispatch(queueAction(QUEUE_TYPE$3, id));
  dispatch(
    debounceAction(QUEUE_TYPE$3, () => {
      dispatch(optimizeAction(QUEUE_TYPE$3));
      const store = getState(); // @ts-ignore

      store.tmp.notify.forEach(target => onNotify(new KeyChain(target), store.data[target].state)); // Clear

      dispatch(queueAction(QUEUE_TYPE$3));
    })
  );
};

const TYPE$b = 'state:value:push';

const action$3 = (id, state, touch = true) => ({
  type: TYPE$b,
  id,
  state,
  touch
});
/**
 * This action type takes the element of which
 * its state should be modified.
 *
 * NOTE: Uses redux-thunk
 *
 * @param {string} id The string keyChain of the object
 * @param {*} state The value of the new state
 * @param {boolean?} touch Whether to touch the value (true)
 */

const pushState = (id, state, touch = true) => (dispatch, getState) => {
  if (!canEdit(getState, id)) return;
  dispatch(action$3(id, state, touch));
  dispatch(
    validateState(
      [id], // @ts-ignore
      getState().data[id].state != null
    )
  );
  dispatch(notifyState(id));
};
var PushState = {
  type: TYPE$b,

  handler(state, action) {
    // @ts-ignore
    const node = state.data[action.id];
    if (action.touch) node.dirty = true;
    node.state = action.state;
    validate(state, {
      source: action.id
    });
    return state;
  }
};

const TYPE$c = 'state:set-value';
/**
 * This action enables or disables the cloning extension of the node.
 *
 */

const setValue$1 = (id, opts) => ({
  type: TYPE$c,
  id,
  rule: opts.rule,
  key: opts.key,
  value: opts.value
});
var SetValue = {
  type: TYPE$c,

  handler(state, action) {
    if (!canEdit(state)) return state;
    mutate.setValue(
      {
        source: action.id,
        rule: action.rule,
        key: action.key,
        value: action.value
      },
      state
    );
    return state;
  }
};

const TYPE$d = 'state:set-label';
/**
 * This action sets label of the node.
 *
 */

const setLabel$1 = (id, opts) => {
  return {
    type: TYPE$d,
    id,
    rule: opts.rule,
    key: opts.key,
    value: opts.value
  };
};
var SetLabel = {
  type: TYPE$d,

  handler(state, action) {
    if (!canEdit(state)) return state;
    mutate.setLabel(
      {
        source: action.id,
        rule: action.rule,
        key: action.key,
        value: action.value
      },
      state
    );
    return state;
  }
};

const TYPE$e = 'state:clone:toggle';
/**
 * This action enables or disables the cloning extension of the node.
 *
 * @param {string} id The string keyChain of the object
 * @param {boolean} status The value of the new status
 */

const toggleClone = (id, value) => ({
  type: TYPE$e,
  id,
  value
});
var ToggleClone = {
  type: TYPE$e,

  handler(state, action) {
    if (!canEdit(state)) return state;
    mutate.clone.enabled(
      {
        source: action.id,
        value: action.value
      },
      state
    );
    return state;
  }
};

const TYPE$f = 'state:enabled:toggle';

const action$4 = (id, value) => ({
  type: TYPE$f,
  id,
  value
});
/**
 * This action enables or disables the node.
 *
 * NOTE: Uses redux-thunk
 *
 * @param {string} id The string keyChain of the object
 * @param {boolean} status The value of the new status
 */

const toggleEnabled = (id, value) => (dispatch, getState) => {
  if (!canEdit(getState)) return;
  dispatch(action$4(id, value));
  dispatch(validateState([id]));
};
var ToggleEnabled = {
  type: TYPE$f,

  handler(state, action) {
    // @ts-ignore: it is are callable
    mutate.display(
      {
        source: action.id,
        value: action.value
      },
      state
    );
    return state;
  }
};

const TYPE$g = 'state:readOnly:toggle';

const action$5 = (id, value) => ({
  type: TYPE$g,
  id,
  value
});
/**
 * This action enables or disables the node.
 *
 * NOTE: Uses redux-thunk
 *
 * @param {string} id The string keyChain of the object
 * @param {boolean} status The value of the new status
 */

const toggleReadOnly = (id, value) => (dispatch, getState) => {
  if (!canEdit(getState)) return;
  dispatch(action$5(id, value));
  dispatch(validateState([id]));
};
var ToggleReadOnly = {
  type: TYPE$g,

  handler(state, action) {
    // @ts-ignore: it is are callable
    mutate.readOnly(
      {
        source: action.id,
        value: action.value
      },
      state
    );
    return state;
  }
};

const TYPE$h = 'state:nullable:toggle';

const action$6 = (id, value) => ({
  type: TYPE$h,
  id,
  value
});
/**
 * This action makes the node nullable or not.
 *
 * NOTE: Uses redux-thunk
 *
 * @param {string} id The string keyChain of the object
 * @param {boolean} value The value of the new status
 */

const toggleNullable = (id, value) => (dispatch, getState) => {
  if (!canEdit(getState)) return;
  dispatch(action$6(id, value));
  dispatch(validateState([id]));
};
var ToggleNullable = {
  type: TYPE$h,

  handler(state, action) {
    // @ts-ignore: it is are callable
    mutate.require(
      {
        source: action.id,
        value: action.value
      },
      state
    );

    return state;
  }
};

/**
 * Helper function for copy action
 * determines value-to-copy for the target field
 *
 * @param {Record<string, boolean>} conditions The record for each target field whether it should be copied or not (emtpy string)
 * @param {string} target The target field name
 * @param {boolean} match Whether the current condition is met or not
 * @param {(string|number|boolean)} state The value of the new state
 * @param {IStore} store The whole state tree
 */

const _setCopiedValue = (conditions, target, match, state, store) => {
  let reset = false;

  if (Object.keys(conditions).includes(target)) {
    if (conditions[target]) {
      conditions[target] = match;
    }
  } else {
    conditions[target] = match;
  } // @ts-ignore

  const targetNode = store.data[target];

  if (!targetNode.options.map(opt => opt.key).includes(state)) {
    // if target node options do not contain state -> reset
    reset = true;
  }

  if (conditions[target]) {
    // if reset is true, reset target; otherwise, copy value
    return reset ? '' : state;
  } else {
    return targetNode && targetNode.state ? targetNode.state : '';
  }
};

const _checkRefNode = (type, ref, match, store) => {
  let result = match; // @ts-ignore

  const refNode = store.data[ref];

  if (refNode.extensions) {
    for (const extension of refNode.extensions) {
      if (extension.type === type) {
        let refMatch = true; // @ts-ignore

        if (extension.pattern) refMatch = new RegExp(extension.pattern).test(String(refNode.state)); // @ts-ignore

        if (extension.not) refMatch = !refMatch;
        result = result && refMatch;
      }
    }
  }

  return result;
};
/**
 * This action type takes the element of which
 * its state should be extended from.
 *
 * Uses: Redux-Thunk
 *
 * @param {string} id The string keyChain of the object
 * @param {(string|number|boolean)} state The value of the new state
 */

const extendState = (id, state) => (dispatch, getState) => {
  const store = getState();
  if (!has$2(store.data, id)) return; // @ts-ignore

  const node = store.data[id];
  const diff = node.state !== state;
  diff && dispatch(pushState(id, state, false));
  if (!has$2(node, 'extensions') || !node.enabled) return;
  let willDerive = false;
  const conditions = {};
  node.extensions.forEach(ext => {
    const { type, target } = ext;

    switch (type) {
      case 'readOnly':
        return diff && dispatch(toggleReadOnly(target));

      case 'reset':
        // Reset target field if current field is changed
        return diff && dispatch(extendState(target, ''));

      case 'clone':
        return diff && node.source.extensions['clone.enabled'] && dispatch(extendState(target, state));

      case 'clone.enabled':
        return diff && dispatch(toggleClone(target));

      case 'copy': {
        const { pattern, not, key, lookup } = ext;
        let match = true;
        if (!has$2(store.data, lookup)) return; // @ts-ignore

        const lookupNode = store.data[lookup];
        if (!lookupNode) return;
        if (pattern) match = new RegExp(pattern).test(String(lookupNode.state)); // if source is the same as lookup, check if source matches pattern

        if (lookup === id) match = new RegExp(pattern).test(String(state));
        if (not) match = !match; // Note: New copy is a wrapper of setValue
        // Passing dummy rule as it's meaningless in such cases
        // 2023-04-21-bugfix: enum type needs to clone options; thus, it cannot use setValue
        // 2023-04-25-bugfix: update default behavior:
        // if state is not part of options, reset dropdown selected to empty
        // Ensure multi-condition cases are respecting anything that is mismatched

        if (node.type === 'enum') {
          return diff && dispatch(extendState(target, _setCopiedValue(conditions, target, match, state, store)));
        } else {
          return (
            diff &&
            match &&
            dispatch(
              setValue$1(target, {
                rule: '',
                key,
                value: state
              })
            )
          );
        }
      }

      case 'setValue': {
        const { rule, pattern, not, key, value } = ext;
        let match = true;
        if (pattern) match = new RegExp(pattern).test(String(state));
        if (not) match = !match;
        return (
          diff &&
          match &&
          dispatch(
            setValue$1(target, {
              rule,
              key,
              value
            })
          )
        );
      }

      case 'setLabel': {
        const { rule, lookup, pattern, not, replace, value } = ext; // @ts-ignore

        const conditionNode = store.data[lookup];
        let match = true; // @ts-ignore

        if (pattern) match = new RegExp(pattern).test(String(conditionNode.state));
        if (not) match = !match; // @ts-ignore

        const finalValue = match ? replace[String(state)] || value : value;
        return dispatch(
          setLabel$1(target, {
            rule,
            value: finalValue || rule
          })
        );
      }

      case 'display':
        return diff && dispatch(toggleEnabled(target));

      case 'show': {
        const { pattern, ref, not } = ext;
        let match = true; // @ts-ignore

        if (pattern) match = new RegExp(pattern).test(String(state));
        if (not) match = !match;
        match = _checkRefNode(type, ref, match, store); // @ts-ignore

        const targetNode = store.data[target];

        if (match === targetNode.enabled) {
          break;
        } else {
          return dispatch(toggleEnabled(target, !targetNode.enabled));
        }
      }

      case 'require':
        return diff && dispatch(toggleNullable(target));

      case 'derive':
        willDerive = true;
    }

    return null;
  });
  if (willDerive) dispatch(deriveState(id));
  if (has$2(node, 'autocomplete')) dispatch(autocompleteState(id));
};

const TYPE$i = 'state:array:pop';

const action$7 = (id, childId) => ({
  type: TYPE$i,
  id,
  childId
});
/**
 * This action will eliminate child from array.
 */

const popArray = (id, childId) => (dispatch, getState) => {
  if (!canEdit(getState)) return;
  dispatch(action$7(id, childId));
  dispatch(validateState([id]));
};
var PopArray = {
  type: TYPE$i,

  handler(state, action) {
    expand.list.remove(
      {
        source: action.id,
        target: action.childId
      },
      state
    );
    return state;
  }
};

const TYPE$j = 'state:record:toggle';

const action$8 = (id, value) => ({
  type: TYPE$j,
  id,
  value
});
/**
 * This action type takes the element of which
 * its state should be toggled.
 */

const toggleState = (id, value) => (dispatch, getState) => {
  if (!canEdit(getState)) return;
  dispatch(action$8(id, value));
  dispatch(validateState([id]));
};
var ToggleState = {
  type: TYPE$j,

  handler(state, action) {
    // @ts-ignore
    const node = state.data[action.id];
    node.state = action.value == null ? !node.state : !!action.value;
    return state;
  }
};

const clearNode = id => (dispatch, getState) => {
  const state = getState();

  const stack = [id],
    next = x => stack.push(x);

  while (stack.length) {
    const id = stack.pop(),
      node = state.data[id];

    switch (node.type) {
      case 'record':
        node.fields.forEach(next); // Hide node given it's optional

        if (node.nullable) dispatch(toggleState(id, false));
        break;

      case 'split':
        node.left.forEach(next);
        node.right.forEach(next);
        break;

      case 'union':
        node.options.forEach(next);
        dispatch(extendState(id, null));
        break;

      case 'list':
      case 'map':
        if (node.state) node.state.forEach(childId => dispatch(popArray(id, childId)));
        dispatch(extendState(id, null));
        break;

      default:
        dispatch(extendState(id, null));
    }
  }
};

const TYPE$k = 'state:array:push';

const action$9 = id => ({
  type: TYPE$k,
  id
});
/**
 * This action will add a child to the array.
 */

const pushArray = id => (dispatch, getState) => {
  if (!canEdit(getState)) return;
  dispatch(action$9(id));
  dispatch(validateState([id]));
};
var PushArray = {
  type: TYPE$k,

  handler(state, action) {
    expand.list.add(
      state.opts.callbacks.uniqueId,
      {
        source: action.id
      },
      state
    );
    return state;
  }
};

const TYPE$l = 'view:touch:all';

const action$a = () => ({
  type: TYPE$l
});
/**
 * This action type takes the element of which
 * is supposed to be valid.
 */

const syncTouchAll = () => (dispatch, getState) => {
  const state = getState();
  if (!canEdit(state)) return;
  dispatch(action$a());
  dispatch(syncValidateState(state.opts.seed));
};
/**
 * Will make all reacheable fields dirty
 */

const helper = (state, stack) => {
  if (!stack.length) return;
  const id = stack.pop();
  const node = state.data[id];

  const next = x => stack.push(x);

  if (node && node.enabled && (node.type !== 'record' || node.state)) {
    if (node.type === 'split') {
      node.left.forEach(next);
      node.right.forEach(next);
    } else if (node.type === 'map')
      node.state &&
        node.state.forEach(x => {
          next(new KeyChain(x).push(MAP_ID).join());
          next(x);
        });
    else if (node.type === 'list') node.state && node.state.forEach(next);
    else if (node.type === 'union') {
      node.dirty = true;
      node.state && stack.push(node.state);
    } else if (node.type === 'record') node.fields.forEach(next);
    // Values
    else {
      node.dirty = true;
      validate(state, {
        source: id
      });
    }
  }
};
var TouchAll = {
  type: TYPE$l,

  handler(state) {
    const stack = [...state.opts.seed];

    while (stack.length) helper(state, stack);

    return state;
  }
};

const TYPE$m = 'view:touch:once';

const action$b = id => ({
  type: TYPE$m,
  id
});
/**
 * This action type takes the element of which
 * is supposed to be valid.
 */

const touchField = id => (dispatch, getState) => {
  const state = getState(); // @ts-ignore

  if (!canEdit(state, id) || state.data[id].dirty) return;
  dispatch(action$b(id));
  dispatch(syncValidateState([id]));
};
var TouchField = {
  type: TYPE$m,

  handler(state, action) {
    // @ts-ignore
    const node = state.data[action.id];
    node.dirty = true;
    return state;
  }
};

const makeReducer = (...reducers) =>
  reducers.reduce(
    (acc, { type, handler }) =>
      Object.assign(acc, {
        [type]: handler
      }),
    {}
  );
var reducers = makeReducer(
  AutoCompleteState,
  DeriveState,
  ExpandCollapsible,
  MarkInit,
  PopArray,
  PushArray,
  PushMode,
  PushState,
  ReorderArray,
  ...QueueAction$1,
  ToggleClone,
  SetValue,
  SetLabel,
  ToggleEnabled,
  ToggleReadOnly,
  ToggleLock,
  ToggleNullable,
  ToggleState,
  ToggleVisible,
  TouchAll,
  TouchField,
  ValidateState
);

const classPrefix = 'bbds-form';
const splitBase = `${classPrefix}-split`;
const listBase = `${classPrefix}-list`;
const mapBase = `${classPrefix}-map`;
const recBase = `${classPrefix}-record`;
const btnBase = `${classPrefix}-btn`;
const NAME = {
  SPLIT: {
    BASE: splitBase,
    LEFT: `${splitBase}-left`,
    RIGHT: `${splitBase}-right`
  },
  UNION: `${classPrefix}-union`,
  CARD: `${classPrefix}-section`,
  LIST: {
    BASE: listBase,
    ITEM: {
      NULL: `${listBase}-item`,
      NOT_NULL: `${listBase}-required-item`
    },
    GROUP: `${listBase}-group`,
    LABEL: `${listBase}-label`
  },
  MAP: {
    NULL: `${mapBase}-item`,
    NOT_NULL: `${mapBase}-required-item`
  },
  RECORD: {
    NULL: recBase,
    NON_NULL: `${recBase}-required`,
    LABEL: `${recBase}-label`
  },
  TOOLTIP: `${classPrefix}-tooltip`,
  LABEL: {
    NULL: `${classPrefix}-label`,
    NOT_NULL: `${classPrefix}-required-label`,
    UI: `${classPrefix}-ui-label`,
    VALUE: `${classPrefix}-ui-value`
  },
  MENU: `${classPrefix}-menu`,
  BTN: {
    BASE: btnBase,
    ADD: `${btnBase}-add`,
    NULL: `${btnBase}-null`,
    HIDE: `${btnBase}-hide`,
    REMOVE: `${btnBase}-remove`
  }
};
const DEFAULT_STYLES = {
  columns: {
    map: {
      key: 'col-6',
      value: 'col-6'
    },
    split: 'col-lg-6',
    label: 'col-md-3',
    value: 'col-md-9'
  },
  menu: {
    base: 'dropdown d-inline-block mr-1',
    menu: 'dropdown-menu',
    item: 'dropdown-item',
    form: 'form-inline'
  },
  sections: {
    base: 'card',
    head: 'card-header',
    body: 'card-body' // panel-body
  },
  buttons: {
    menu: 'btn-link',
    form: 'btn-primary',
    base: 'btn btn-sm',
    add: 'btn-outline-success',
    null: 'btn-link',
    remove: 'btn-outline-danger'
  },
  known: {
    true: 'badge badge-pill badge-success',
    false: 'badge badge-pill badge-danger'
  },
  icons: {
    menu: 'fas fa-ellipsis-v',
    form: 'fas fa-arrow-right',
    edit: 'fas fa-edit',
    clear: 'fas fa-eraser',
    up: 'fas fa-caret-left',
    tip: 'far fa-question-circle',
    down: 'fas fa-caret-down'
  }
};

const LabelWrapperTooltip = props => {
  const elem = createRef();
  useEffect(() => {
    const $ = externals.jquery.get();

    if ($ && elem.current) {
      // @ts-ignore
      $(elem.current).tooltip();
    }
  }, []);
  if (!props.text || !externals.hasTooltips()) return null;
  return createElement('i', {
    ref: elem,
    className: classNames('ml-1', NAME.TOOLTIP, props.styles.icons.tip, props.className, 'text-muted'),
    title: props.text
  });
};
const LabelWrapperLabel = props =>
  createElement(
    Fragment,
    null,
    createElement(
      'label',
      {
        htmlFor: props.htmlFor,
        className: props.className
      },
      props.text
    ),
    createElement(LabelWrapperTooltip, {
      text: props.help,
      styles: props.styles
    })
  );

const LabelWrapper = props =>
  createElement(
    Fragment,
    null,
    props.label.menu,
    createElement(
      'span',
      null,
      props.label.elem ||
        createElement(LabelWrapperLabel, {
          htmlFor: props.htmlFor,
          className: props.className,
          text: props.label.text,
          help: props.label.help,
          styles: props.styles
        })
    )
  );

const ValueLabel = props => {
  const isMap = props.isMap || isValidElement(props.label.elem);
  const labelClassName = classNames(
    props.label.bold && 'font-weight-bold',
    props.label.nullable ? NAME.LABEL.NULL : NAME.LABEL.NOT_NULL
  );
  return createElement(
    'div',
    {
      className: classNames(props.className, !props.embed && 'form-group', NAME.LABEL.UI, NAME.LABEL.VALUE)
    },
    createElement(
      'span',
      null,
      createElement(
        'div',
        {
          className: 'row'
        },
        createElement(
          'div',
          {
            className: classNames(
              isMap ? props.styles.columns.map.key : classNames('col-form-label', props.styles.columns.label),
              NAME.LABEL.UI
            )
          },
          createElement(LabelWrapper, {
            htmlFor: props.htmlFor,
            label: props.label,
            styles: props.styles,
            className: labelClassName
          })
        ),
        createElement(
          'div',
          {
            className: isMap ? props.styles.columns.map.value : props.styles.columns.value
          },
          props.children
        )
      )
    ),
    props.label.action
  );
};

const ErrorLabel = props => {
  if (props.disabled) return null;
  let once = false;
  return createElement(
    'div',
    {
      className: 'invalid-feedback'
    },
    Array.isArray(props.text)
      ? props.text.map((line, index) => {
          if (!once) {
            once = true;
            return line;
          }

          return createElement(
            Fragment,
            {
              key: index
            },
            createElement('br', null),
            line
          );
        })
      : props.text
  );
};

const SelectOptions = props =>
  createElement(
    Fragment,
    null,
    props.nullable || !props.value
      ? createElement(
          'option',
          {
            key: 'null',
            value: ''
          },
          props.options.length ? props.placeholder : props.value || 'Not Applicable'
        )
      : null,
    props.options.map(x => {
      if (typeof x === 'string' || typeof x === 'number') {
        x = {
          key: x
        };
      }

      return props.readOnly
        ? createElement(
            'option',
            {
              key: x.key,
              value: x.key,
              disabled: true
            },
            x.value || x.key
          )
        : createElement(
            'option',
            {
              key: x.key,
              value: x.key
            },
            x.value || x.key
          );
    })
  );

const Select = _ref => {
  let { className, dataKey, dirty, error, nullable, options, placeholder, onBlur, readOnly } = _ref,
    props = _objectWithoutProperties(_ref, [
      'className',
      'dataKey',
      'dirty',
      'error',
      'nullable',
      'options',
      'placeholder',
      'onBlur',
      'readOnly'
    ]);

  const invalid = dirty && !!error;
  props.disabled = props.disabled || !options.length;
  return createElement(
    'div',
    {
      className: className
    },
    createElement(
      'select',
      _extends({}, props, {
        onBlur: dirty ? null : onBlur,
        'data-key': dataKey,
        value: props.value || '',
        'aria-disabled': props.disabled ? 'true' : 'false',
        className: classNames('form-control', invalid && 'is-invalid', readOnly && 'bbds-form-read-only')
      }),
      createElement(SelectOptions, {
        readOnly: readOnly || false,
        value: props.value,
        nullable: nullable,
        options: options,
        placeholder: placeholder
      })
    ),
    createElement(ErrorLabel, {
      disabled: !invalid || props.disabled,
      text: error
    })
  );
};

const ActionLabels = {
  ['CLEAR']:
    /* CLEAR */
    'Clear Values',
  ['EDIT']:
    /* EDIT */
    'Edit Values',
  ['EXPAND']:
    /* EXPAND */
    'Expand',
  ['COLLAPSE']:
    /* COLLAPSE */
    'Collapse',
  ['REMOVE']:
    /* REMOVE */
    'Remove'
};

const actionGet = cb => (context = null) => {
  if (!context) return null;
  const theirLabel = cb(context);
  if (theirLabel) return theirLabel;
  if (context.action in ActionLabels) return ActionLabels[context.action];

  switch (context.action) {
    case 'ADD':
      /* ADD */
      return `Add${context.subject ? ` ${context.subject}` : ''}`;

    case 'LABEL':
      /* LABEL */
      return `${context.subject ? `${context.subject} ` : ''}#${context.index + 1}`;

    case 'KEY':
      /* KEY */
      return `${context.subject ? `${context.subject} ` : ''}Key #${context.index + 1}`;

    default:
      throw new Error('Unknown action type.');
  }
};

const passthrough = x => x;
const labelGet = (id, node, cb) => cb(new KeyChain(id)) || (node.type === 'split' ? null : node.label);
const getDefaultSelector = createSelector(
  state => ({
    mode: state.mode,
    styles: state.opts.styles
  }),
  passthrough
);
const getGetActionSelector = createSelector(
  state => ({
    cb: state.opts.callbacks.actionGet
  }),
  ({ cb }) => ({
    getActionLabel: actionGet(cb)
  })
);
const makeGetDataKeySelector = () =>
  createSelector(
    [
      (_, ownProps) => ({
        id: ownProps.id
      })
    ],
    ({ id }) => ({
      dataKey: new KeyChain(id).key
    })
  );
const makeGetNodeSelector = combiner => createSelector([(state, ownProps) => state.data[ownProps.id]], combiner);

function makeMapStateToProps(...selectors) {
  return (state, ownProps) => selectors.reduce((props, select) => Object.assign(props, select(state, ownProps)), {});
}

const EnumCore = _ref => {
  let { id, dataKey, mode, styles } = _ref,
    props = _objectWithoutProperties(_ref, ['id', 'dataKey', 'mode', 'styles']);

  props.placeholder = props.placeholder ? `Select ${props.placeholder}` : 'Select an option.';

  if (mode === 'view') {
    const opt =
      props.options &&
      props.value &&
      props.options.filter(opt => (typeof opt === 'object' ? opt.key : opt) === props.value)[0];
    return createElement(
      'div',
      {
        id: id,
        'data-key': dataKey,
        className: classNames((props.value && styles.known[props.value]) || 'form-control form-control-plaintext')
      },
      (typeof opt === 'object' ? opt.value : opt) || props.value || 'Not Available'
    );
  }

  return createElement(
    Select,
    _extends({}, props, {
      disabled: mode !== 'edit'
    })
  );
};
const Enum = _ref2 => {
  let { callOnInit, help, label, nullable, panel, union, onInit } = _ref2,
    props = _objectWithoutProperties(_ref2, ['callOnInit', 'help', 'label', 'nullable', 'panel', 'union', 'onInit']);

  useEffect(() => {
    // Init autocomplete
    if (callOnInit) {
      onInit(); // @ts-ignore: to be removed

      props.onChange({
        target: {
          value: props.value
        }
      });
    }
  }, [callOnInit]);
  if (nullable && ((props.mode !== 'view' && !props.options.length) || (props.mode === 'view' && !props.value)))
    return null;
  const elem = createElement(EnumCore, props); // No label means pure element.

  if (label == null) return elem;
  return createElement(
    ValueLabel,
    {
      styles: props.styles,
      label: _objectSpread2({}, label, {
        help,
        bold: !!union && !panel,
        nullable: nullable || props.mode === 'view'
      }),
      embed: !!union && panel
    },
    elem
  );
};
const getOptionsSelector = createSelector(
  (state, ownProps) => ({
    id: ownProps.id,
    data: state.data,
    union: ownProps.union,
    cb: state.opts.callbacks.labelGet
  }),
  ({ id, data, union, cb }) => ({
    options: union
      ? union.map(key => ({
          key,
          value: labelGet(key, data[key], cb)
        }))
      : data[id].options
  })
);
const mapStateToProps = makeMapStateToProps(
  getDefaultSelector,
  getOptionsSelector,
  makeGetDataKeySelector(),
  makeGetNodeSelector(({ init, state, nullable, dirty, error, extensions, help, readOnly }) => ({
    value: state || '',
    nullable,
    dirty,
    error,
    help,
    callOnInit: !init && extensions.some(({ type }) => type === 'derive'),
    readOnly
  }))
);

const mapDispatchToProps = (dispatch, ownProps) => ({
  onChange: e => dispatch(extendState(ownProps.id, e.target.value)),
  onBlur: () => dispatch(touchField(ownProps.id)),
  onInit: () => dispatch(markInit(ownProps.id))
});

var Enum$1 = connect(mapStateToProps, mapDispatchToProps)(Enum);

const Input = _ref => {
  let { className, dataKey, dirty, error, onBlur } = _ref,
    props = _objectWithoutProperties(_ref, ['className', 'dataKey', 'dirty', 'error', 'onBlur']);

  const invalid = dirty && !!error;
  return createElement(
    'div',
    {
      className: className
    },
    createElement(
      'input',
      _extends({}, props, {
        onBlur: dirty ? null : onBlur,
        'data-key': dataKey,
        'aria-disabled': props.disabled ? 'true' : 'false',
        className: classNames('form-control', invalid && 'is-invalid')
      })
    ),
    createElement(ErrorLabel, {
      disabled: !invalid || props.disabled,
      text: error
    })
  );
};

const ValueCore = _ref => {
  let { autocomplete, id, dataKey, mode } = _ref,
    props = _objectWithoutProperties(_ref, ['autocomplete', 'id', 'dataKey', 'mode']);

  if (mode === 'view')
    return createElement(
      'div',
      {
        id: id,
        className: 'form-control form-control-plaintext',
        'data-key': dataKey
      },
      props.value || 'Not Available'
    );
  let datalist = null;
  const datalistId = new KeyChain(id).push('_Datalist').join();

  if (autocomplete) {
    datalist = createElement(
      'datalist',
      {
        id: datalistId
      },
      autocomplete.map(({ code, display }) =>
        createElement(
          'option',
          {
            key: code,
            value: code
          },
          display
        )
      )
    );
  }

  return createElement(
    Fragment,
    null,
    createElement(
      Input,
      _extends({}, props, {
        readOnly: props.readOnly || false,
        disabled: mode !== 'edit',
        list: datalist ? datalistId : null
      })
    ),
    datalist
  );
};
const Value = _ref2 => {
  let { help, label, nullable, onInit, styles, callOnInit } = _ref2,
    props = _objectWithoutProperties(_ref2, ['help', 'label', 'nullable', 'onInit', 'styles', 'callOnInit']);

  useEffect(() => {
    // Init autocomplete
    if (callOnInit) {
      onInit(); // @ts-ignore: to be removed

      props.onChange({
        target: {
          value: props.value
        }
      });
    }
  }, [callOnInit]);
  if (props.mode === 'view' && nullable && !props.value) return null;
  const elem = createElement(ValueCore, props); // No label means pure element.

  if (label == null) return elem;
  return createElement(
    ValueLabel,
    {
      styles: styles,
      label: _objectSpread2({}, label, {
        help,
        nullable: nullable || props.mode === 'view'
      })
    },
    elem
  );
};
const mapStateToProps$1 = makeMapStateToProps(
  getDefaultSelector,
  makeGetDataKeySelector(),
  makeGetNodeSelector(
    ({
      state,
      init,
      nullable,
      help,
      dirty,
      error,
      maxLength,
      autocomplete = {
        options: []
      },
      readOnly
    }) => ({
      value: state || '',
      nullable,
      help,
      dirty,
      error,
      maxLength: maxLength || null,
      autocomplete: autocomplete.options,
      callOnInit: !init && Boolean(autocomplete.options),
      readOnly
    })
  )
);

const mapDispatchToProps$1 = (dispatch, ownProps) => ({
  onChange: e => dispatch(extendState(ownProps.id, e.target.value)),
  onBlur: () => dispatch(touchField(ownProps.id)),
  onInit: () => dispatch(markInit(ownProps.id))
});

var Value$1 = connect(mapStateToProps$1, mapDispatchToProps$1)(Value);

const Button = props =>
  createElement(
    'button',
    {
      type: 'button',
      onClick: () => !props.disabled && (props.onClick.length ? props.onClick(props.id) : props.onClick()),
      disabled: props.disabled,
      'aria-disabled': props.disabled ? 'true' : 'false',
      className: classNames(props.styles.buttons.base, NAME.BTN.BASE, props.className)
    },
    props.children
  );

const ListMenuMove = props => {
  const delta = props.max ? 1 : -1,
    label = props.max ? 'down' : 'up',
    bounded = props.max ? props.index < props.max - 1 : props.index > 0;
  if (!bounded) return null;
  return createElement(
    'a',
    {
      className: props.styles.menu.item,
      onClick: e => {
        e.preventDefault();
        props.onClick(props.index, props.index + delta);
      },
      href: '#'
    },
    'Move ',
    label
  );
};
const ListMenuMoveTo = props => {
  const [value, setValue] = useState(props.index + 1);
  if (props.max <= 3 && (props.max !== 3 || props.index === 1)) return null;
  const badValue = isNaN(value) || value < 1 || value > props.max || value === props.index + 1;
  return createElement(
    'div',
    {
      className: 'px-4 py-3'
    },
    createElement(
      'label',
      {
        className: 'mr-1'
      },
      'Move to'
    ),
    createElement(
      'div',
      {
        className: classNames('input-group', props.styles.menu.form)
      },
      createElement('input', {
        className: 'form-control',
        onChange: e => setValue(+e.target.value),
        disabled: props.disabled,
        'aria-disabled': props.disabled ? 'true' : 'false',
        value: value,
        placeholder: 'Index'
      }),
      createElement(
        'div',
        {
          className: 'input-group-append'
        },
        createElement(
          Button,
          {
            styles: props.styles,
            disabled: props.disabled || badValue,
            onClick: () => props.onClick(props.index, value - 1),
            className: props.styles.buttons.form
          },
          createElement('i', {
            className: props.styles.icons.form
          })
        )
      )
    )
  );
};

const ListMenu = props => {
  if (props.max < 2 || !externals.hasTooltips()) return null;
  return createElement(
    'div',
    {
      className: classNames(props.styles.menu.base, NAME.MENU)
    },
    createElement(
      'button',
      {
        type: 'button',
        disabled: props.disabled,
        'aria-disabled': props.disabled ? 'true' : 'false',
        'data-toggle': 'dropdown',
        'aria-haspopup': 'true',
        'aria-expanded': 'false',
        className: classNames(props.styles.buttons.base, NAME.BTN.BASE, props.styles.buttons.menu)
      },
      createElement('i', {
        className: props.styles.icons.menu
      })
    ),
    createElement(
      'div',
      {
        className: props.styles.menu.menu
      },
      createElement(ListMenuMove, {
        styles: props.styles,
        onClick: props.reorderOnClick,
        index: props.index
      }),
      createElement(ListMenuMoveTo, {
        styles: props.styles,
        onClick: props.reorderOnClick,
        index: props.index,
        max: props.max,
        disabled: props.disabled
      }),
      createElement(ListMenuMove, {
        styles: props.styles,
        onClick: props.reorderOnClick,
        index: props.index,
        max: props.max
      })
    )
  );
};

const RecordLabelShowHideButton = props => {
  if (!props.onClickShowHide || props.isNull) return null;
  return createElement(
    Button,
    {
      styles: props.styles,
      onClick: props.onClickShowHide,
      className: classNames(props.styles.buttons.null, NAME.BTN.HIDE)
    },
    props.getActionLabel({
      action: props.visible
        ? 'COLLAPSE'
        : /* COLLAPSE */
          'EXPAND'
      /* EXPAND */
    }),
    createElement('i', {
      className: classNames(props.visible ? props.styles.icons.down : props.styles.icons.up)
    })
  );
};
const RecordLabelCreateDestroyButton = props => {
  if (!props.onClickCreateDestroy || !props.label.nullable) return null;
  let icon;
  let action;
  let className;

  if (!props.destructive) {
    if (props.isNull) {
      icon = createElement('i', {
        className: classNames(props.styles.icons.edit)
      });
      action = 'EDIT';
      /* EDIT */
    } else {
      icon = createElement('i', {
        className: classNames(props.styles.icons.clear)
      });
      action = 'CLEAR';
      /* CLEAR */
    }

    className = classNames(props.styles.buttons.null, NAME.BTN.NULL);
  } else if (props.isNull) {
    action = 'ADD';
    /* ADD */
    className = classNames(props.styles.buttons.add, NAME.BTN.ADD);
  } else {
    action = 'REMOVE';
    /* REMOVE */
    className = classNames(props.styles.buttons.remove, NAME.BTN.REMOVE);
  }

  return createElement(
    Button,
    {
      styles: props.styles,
      onClick: props.onClickCreateDestroy,
      disabled: props.mode !== Store.EMode.EDIT,
      className: className
    },
    icon,
    props.getActionLabel({
      action
    })
  );
};
const RecordLabelActions = props =>
  createElement(
    Fragment,
    null,
    createElement(RecordLabelShowHideButton, props),
    createElement(RecordLabelCreateDestroyButton, props),
    props.label.action
  );

const RecordLabel = props => {
  // Hide if collapsed or null
  const show =
    props.isNull || !props.visible
      ? {
          style: {
            display: 'none'
          }
        }
      : null;
  const panelClass = props.panel
    ? {
        className: props.styles.sections.body
      }
    : null;
  return createElement(
    'div',
    {
      className: classNames(props.className, props.panel && props.styles.sections.base, 'form-group')
    },
    createElement(
      'div',
      {
        className: classNames(
          props.panel && props.styles.sections.head,
          NAME.RECORD.LABEL,
          NAME.LABEL.UI,
          props.label.elem && NAME.LABEL.VALUE
        )
      },
      createElement(
        LabelWrapper,
        _extends(
          {
            styles: props.styles,
            className: classNames('font-weight-bold', 'mb-0')
          },
          props
        )
      ),
      createElement(RecordLabelActions, props)
    ),
    createElement('div', _extends({}, panelClass, show), props.children)
  );
};

const IterableItem = props => {
  const childLabel = _objectSpread2({}, props.label, {
    text: props.getActionLabel({
      action: 'LABEL',
      /* LABEL */
      subject: props.label.text,
      index: props.index
    })
  });

  if (props.nullable || props.index || props.state.length > 1 || !props.autoExpandIfEmpty) {
    childLabel.className = props.labelEnum.NULL;
    if (props.mode !== 'view')
      childLabel.action = createElement(
        Button,
        {
          id: props.id,
          styles: props.styles, // @ts-ignore: Fails for some reason?
          onClick: props.removeOnClick,
          disabled: props.mode !== 'edit',
          className: classNames(props.styles.buttons.remove, NAME.BTN.REMOVE)
        },
        props.getActionLabel({
          action: 'REMOVE'
          /* REMOVE */
        })
      );
  }

  if (props.mode !== 'view')
    childLabel.menu = createElement(ListMenu, {
      styles: props.styles,
      reorderOnClick: props.reorderOnClick,
      disabled: props.mode !== 'edit',
      index: props.index,
      max: props.state.length
    });
  if (props.isMap)
    childLabel.elem = createElement(Value$1, {
      id: toMapId(props.id),
      label: null,
      placeholder: props.getActionLabel({
        action: 'KEY',
        /* KEY */
        subject: props.label.text,
        index: props.index
      })
    });
  const elem = createElement(Boundary$1, {
    id: props.id,
    label: childLabel
  });
  if (props.isMap || !props.split) return elem;
  return createElement(
    'div',
    {
      className: props.styles.columns.split
    },
    elem
  );
};
const IterableItems = _ref => {
  let { id, dataKey, className, addOnClick } = _ref,
    props = _objectWithoutProperties(_ref, ['id', 'dataKey', 'className', 'addOnClick']);

  return createElement(
    'div',
    {
      id: id,
      'data-key': dataKey,
      className: classNames(NAME.LIST.BASE, 'form-group')
    },
    props.label.elem,
    createElement(
      'div',
      {
        className: classNames(className, NAME.LIST.GROUP, !props.isMap && props.split && 'row')
      },
      props.state &&
        props.state.map((childId, index) =>
          createElement(
            IterableItem,
            _extends(
              {
                key: childId,
                id: childId,
                index: index
              },
              props
            )
          )
        )
    ),
    props.mode === 'view' ||
      createElement(
        Button,
        {
          onClick: addOnClick,
          styles: props.styles,
          disabled: props.mode !== 'edit',
          className: classNames(props.styles.buttons.add, NAME.BTN.ADD)
        },
        props.getActionLabel({
          action: 'ADD',
          /* ADD */
          subject: props.label.text
        })
      )
  );
};
const Iterable = _ref2 => {
  let { className, help, label, onDisplay, showListAndMapLabels, visible, onInit, callOnInit } = _ref2,
    props = _objectWithoutProperties(_ref2, [
      'className',
      'help',
      'label',
      'onDisplay',
      'showListAndMapLabels',
      'visible',
      'onInit',
      'callOnInit'
    ]);

  useEffect(() => {
    if (callOnInit && props.autoExpandIfEmpty && !props.nullable && !(props.state && props.state.length)) {
      onInit();
      props.addOnClick();
    }
  }, [callOnInit, props.autoExpandIfEmpty, props.nullable]);
  const labelEnum = props.isMap ? NAME.MAP : NAME.LIST.ITEM;
  const list = createElement(
    IterableItems,
    _extends(
      {
        label: _objectSpread2({}, label, {
          elem: null,
          help,
          nullable: false,
          className: labelEnum.NOT_NULL
        }),
        labelEnum: labelEnum
      },
      props
    )
  );
  if (!showListAndMapLabels) return list;
  return createElement(
    RecordLabel,
    {
      mode: props.mode,
      label: _objectSpread2({}, label, {
        help,
        nullable: props.nullable
      }),
      getActionLabel: props.getActionLabel,
      onClickShowHide: onDisplay, // TODO: Enable create/destroy for nullable list/map.
      // For now lists/maps always exist even if they're nullable.
      // It is possible that a null list and an empty list could have different meanings.
      // onClickCreateDestroy={onClickCreateDestroy}
      className: classNames(className, props.nullable ? NAME.RECORD.NULL : NAME.RECORD.NON_NULL),
      styles: props.styles,
      visible: visible
    },
    list
  );
};
const getArraySelector = createSelector(
  state => ({
    autoExpandIfEmpty: state.opts.autoExpandListIfEmpty,
    showListAndMapLabels: state.opts.showListAndMapLabels
  }),
  passthrough
);
const mapStateToProps$2 = makeMapStateToProps(
  getArraySelector,
  getDefaultSelector,
  getGetActionSelector,
  makeGetDataKeySelector(),
  makeGetNodeSelector(({ init, state, nullable, split, help, visible }) => ({
    state,
    nullable,
    split,
    help,
    visible,
    callOnInit: !init
  }))
);

const mapDispatchToProps$2 = (dispatch, ownProps) => ({
  onInit: () => dispatch(markInit(ownProps.id)),
  addOnClick: () => dispatch(pushArray(ownProps.id)),
  reorderOnClick: (from, to) => dispatch(reorderArray(ownProps.id, from, to)),
  removeOnClick: index => dispatch(popArray(ownProps.id, index)),
  onDisplay: () => dispatch(toggleVisible(ownProps.id))
});

var List = connect(mapStateToProps$2, mapDispatchToProps$2)(Iterable);

const Checkbox = _ref => {
  let { checked, className, dataKey, dirty, error, nullable, onBlur, onChange } = _ref,
    props = _objectWithoutProperties(_ref, [
      'checked',
      'className',
      'dataKey',
      'dirty',
      'error',
      'nullable',
      'onBlur',
      'onChange'
    ]);

  const elem = createRef();
  useEffect(() => {
    elem.current.indeterminate = checked == null;
    elem.current.checked = !!checked;
  });
  const invalid = dirty && !!error;
  return createElement(
    'div',
    {
      className: classNames(className, 'form-check mt-2')
    },
    createElement(
      'input',
      _extends({}, props, {
        ref: elem,
        onChange:
          onChange &&
          (e => {
            if (checked == null) e.target.checked = false;
            else if (checked && nullable) e.target.checked = null;
            onChange(e);
          }),
        onBlur: dirty ? null : onBlur,
        type: 'checkbox',
        'data-key': dataKey,
        'aria-disabled': props.disabled ? 'true' : 'false',
        checked: checked || false,
        className: classNames('form-check-input', invalid && 'is-invalid')
      })
    ),
    createElement(ErrorLabel, {
      disabled: !invalid || props.disabled,
      text: error
    })
  );
};

const BoolCore = _ref => {
  let { id, dataKey, mode, styles } = _ref,
    props = _objectWithoutProperties(_ref, ['id', 'dataKey', 'mode', 'styles']);

  if (mode !== Store.EMode.VIEW)
    return createElement(
      Checkbox,
      _extends({}, props, {
        disabled: mode !== 'edit'
      })
    );
  return createElement(
    'p',
    {
      id: id,
      'data-key': dataKey,
      className: classNames('mt-2', props.checked ? styles.known.true : styles.known.false)
    },
    props.checked ? 'true' : 'false'
  );
};
const Bool = _ref2 => {
  let { help, label } = _ref2,
    props = _objectWithoutProperties(_ref2, ['help', 'label']);

  const elem = createElement(BoolCore, props); // No label means pure element.

  if (label == null) return elem;
  return createElement(
    ValueLabel,
    {
      styles: props.styles,
      label: _objectSpread2({}, label, {
        help,
        nullable: true
      }),
      htmlFor: props.id,
      isMap: true
    },
    elem
  );
};
const mapStateToProps$3 = makeMapStateToProps(
  getDefaultSelector,
  makeGetDataKeySelector(),
  makeGetNodeSelector(({ state, help, dirty, error }) => ({
    checked: state,
    help,
    dirty,
    error
  }))
);

const mapDispatchToProps$3 = (dispatch, ownProps) => ({
  onChange: e => dispatch(extendState(ownProps.id, e.target.checked))
});

var Bool$1 = connect(mapStateToProps$3, mapDispatchToProps$3)(Bool);

const Union = props => {
  const label = _objectSpread2({}, props.label, {
    menu: null,
    elem: createElement(Enum$1, {
      id: props.id,
      label: _objectSpread2({}, props.label, {
        action: null
      }),
      panel: props.panel,
      union: props.options
    })
  });

  return props.value
    ? createElement(Boundary$1, {
        id: props.value,
        label: label,
        panel: props.panel
      })
    : createElement(RecordLabel, {
        label: label,
        visible: true,
        isNull: false,
        styles: props.styles,
        panel: props.panel,
        mode: props.mode,
        getActionLabel: props.getActionLabel
      });
};
const mapStateToProps$4 = makeMapStateToProps(
  getDefaultSelector,
  getGetActionSelector,
  makeGetNodeSelector(({ state, options }) => ({
    value: state,
    options
  }))
);
var Union$1 = connect(mapStateToProps$4)(Union);

const SplitCore = props =>
  createElement(
    'div',
    {
      className: props.className
    },
    props.fields.map(x =>
      createElement(Boundary$1, {
        key: x,
        id: x
      })
    )
  );
const Split = props =>
  createElement(
    'div',
    {
      className: classNames(props.className, NAME.SPLIT.BASE, 'row')
    },
    createElement(SplitCore, {
      fields: props.left,
      className: classNames(NAME.SPLIT.LEFT, props.styles.columns.split)
    }),
    createElement(SplitCore, {
      fields: props.right,
      className: classNames(NAME.SPLIT.RIGHT, props.styles.columns.split)
    })
  );
const mapStateToProps$5 = makeMapStateToProps(
  getDefaultSelector,
  makeGetNodeSelector(({ left, right }) => ({
    left,
    right
  }))
);
var Split$1 = connect(mapStateToProps$5)(Split);

const NumberValueCore = _ref => {
  let { id, dataKey, mode } = _ref,
    props = _objectWithoutProperties(_ref, ['id', 'dataKey', 'mode']);

  if (mode !== Store.EMode.VIEW)
    return createElement(
      Input,
      _extends({}, props, {
        disabled: mode !== Store.EMode.EDIT
      })
    );
  return createElement(
    'p',
    {
      id: id,
      'data-key': dataKey,
      className: 'form-control form-control-plaintext'
    },
    props.value || 'Not Available'
  );
};
const NumberValue = _ref2 => {
  let { help, label, nullable, styles } = _ref2,
    props = _objectWithoutProperties(_ref2, ['help', 'label', 'nullable', 'styles']);

  if (props.mode === Store.EMode.VIEW && nullable && props.value == null) return null;
  const elem = createElement(NumberValueCore, props); // No label means pure element.

  if (label == null) return elem;
  return createElement(
    ValueLabel,
    {
      styles: styles,
      label: _objectSpread2({}, label, {
        help,
        nullable: nullable || props.mode === Store.EMode.VIEW
      })
    },
    elem
  );
};
const mapStateToProps$6 = makeMapStateToProps(
  getDefaultSelector,
  makeGetDataKeySelector(),
  makeGetNodeSelector(({ state, nullable, min, max, help, dirty, error }) => ({
    value: state == undefined || state == null ? '' : state,
    nullable,
    min,
    max,
    help,
    dirty,
    error
  }))
);

const mapDispatchToProps$4 = (dispatch, ownProps) => ({
  onChange: e => dispatch(extendState(ownProps.id, e.target.value)),
  onBlur: () => dispatch(touchField(ownProps.id))
});

var NumberValue$1 = connect(mapStateToProps$6, mapDispatchToProps$4)(NumberValue);

const Record = props => {
  if (props.mode === Store.EMode.VIEW && !props.state) return null;
  useEffect(() => {
    if (!props.state && props.nullable && props.mode !== Store.EMode.VIEW && props.autoExpandIfEmpty) props.onChange();
  }, []);
  const elem =
    !props.nullable || props.state || props.label == null
      ? createElement(
          Fragment,
          null,
          props.fields.map(id =>
            createElement(Boundary$1, {
              key: id,
              id: id
            })
          )
        )
      : null;
  if (props.label == null) return elem;
  return createElement(
    RecordLabel,
    {
      label: _objectSpread2({}, props.label, {
        help: props.help,
        nullable: props.nullable
      }),
      isNull: !props.state,
      destructive: props.destructiveClear,
      onClickCreateDestroy: props.destructiveClear && props.state ? props.onClear : props.onChange,
      onClickShowHide: props.onDisplay,
      panel: props.panel,
      styles: props.styles,
      mode: props.mode,
      getActionLabel: props.getActionLabel,
      className: classNames(props.className, props.nullable ? NAME.RECORD.NULL : NAME.RECORD.NON_NULL),
      visible: props.visible
    },
    elem
  );
};
const getRecordSelector = createSelector(
  state => ({
    destructiveClear: state.opts.destructiveClear,
    autoExpandIfEmpty: state.opts.autoExpandRecordIfEmpty
  }),
  passthrough
);
const mapStateToProps$7 = makeMapStateToProps(
  getRecordSelector,
  getDefaultSelector,
  getGetActionSelector,
  makeGetNodeSelector(({ state, visible, fields, help, nullable, extensions }) => ({
    state,
    visible,
    fields,
    help,
    nullable,
    extensions
  }))
);

const mapDispatchToProps$5 = (dispatch, ownProps) => ({
  onClear: () => dispatch(clearNode(ownProps.id)),
  onChange: () => dispatch(toggleState(ownProps.id)),
  onDisplay: () => dispatch(toggleVisible(ownProps.id))
});

var Record$1 = connect(mapStateToProps$7, mapDispatchToProps$5)(Record);

class Boundary extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }

  componentDidCatch(error, info) {
    // Display fallback UI
    this.setState({
      hasError: true
    });
    if (process.env.NODE_ENV === 'development') console.error(error, info); // eslint-disable-line no-console

    this.props.onError(error, info);
  }

  render() {
    const _this$props = this.props,
      { type, name, enabled, panel, label } = _this$props,
      attrs = _objectWithoutProperties(_this$props, ['type', 'name', 'enabled', 'panel', 'label']); // @ts-ignore: added by react-redux

    delete attrs.dispatch;
    delete attrs.onError;
    if (!enabled) return null;

    if (this.state.hasError) {
      return createElement(
        'div',
        {
          className: 'alert alert-danger',
          role: 'alert'
        },
        'Something went wrong.'
      );
    }

    let newLabel = null;
    let strOrLabel = null;
    if (label !== null) strOrLabel = label || name;
    if (typeof strOrLabel === 'string')
      newLabel = {
        text: strOrLabel
      };
    else newLabel = strOrLabel;
    attrs.placeholder = attrs.placeholder || (newLabel && newLabel.text) || name;

    switch (type) {
      case 'enum':
        return createElement(
          Enum$1,
          _extends({}, attrs, {
            label: newLabel
          })
        );

      case 'list':
        return createElement(
          List,
          _extends({}, attrs, {
            label: newLabel
          })
        );

      case 'union':
        return createElement(
          Union$1,
          _extends({}, attrs, {
            panel: panel,
            label: newLabel
          })
        );

      case 'bool':
        return createElement(
          Bool$1,
          _extends({}, attrs, {
            label: newLabel
          })
        );

      case 'value':
        return createElement(
          Value$1,
          _extends({}, attrs, {
            label: newLabel
          })
        );

      case 'number':
        return createElement(
          NumberValue$1,
          _extends({}, attrs, {
            label: newLabel
          })
        );

      case 'record':
        return createElement(
          Record$1,
          _extends({}, attrs, {
            panel: panel,
            label: newLabel
          })
        );

      case 'split':
        return createElement(Split$1, attrs);

      case 'map':
        return createElement(
          List,
          _extends({}, attrs, {
            isMap: true,
            label: newLabel
          })
        );

      default:
        if (process.env.NODE_ENV === 'development') return createElement('p', null, JSON.stringify(attrs));
        return null;
    }
  }
}
const getErrorSelector = createSelector(
  state => ({
    onError: state.opts.callbacks.onError
  }),
  passthrough
);
const getNameSelector = createSelector(
  [
    (state, ownProps) => ({
      id: ownProps.id,
      node: state.data[ownProps.id],
      cb: state.opts.callbacks.labelGet
    })
  ], // Calculations happen here because `reselect` memoizes the value below if inputs didn't change
  ({ id, node, cb }) => ({
    name: labelGet(id, node, cb)
  })
);
const mapStateToProps$8 = makeMapStateToProps(
  getNameSelector,
  getErrorSelector,
  getDefaultSelector,
  makeGetNodeSelector(node => ({
    type: node.type,
    placeholder: 'placeholder' in node ? node.placeholder : null,
    enabled: node.enabled,
    readOnly: node.readOnly
  }))
);
var Boundary$1 = connect(mapStateToProps$8)(Boundary);

const Root = props => {
  if (!props.fields)
    return createElement(Boundary$1, {
      id: props.id,
      panel: true
    });
  return createElement(
    Fragment,
    null,
    props.fields.map(x =>
      createElement(Boundary$1, {
        key: x,
        id: x,
        panel: true
      })
    )
  );
};
const mapStateToProps$9 = makeMapStateToProps(
  makeGetNodeSelector(({ fields }) => ({
    fields
  }))
);
var Root$1 = connect(mapStateToProps$9)(Root);

const App = props =>
  createElement(
    Provider,
    {
      store: props.store
    },
    createElement(
      Fragment,
      null,
      props.panels.map(({ key, expand }) => {
        const id = new KeyChain(key).join();
        return expand
          ? createElement(Root$1, {
              key: id,
              id: id
            })
          : createElement(Boundary$1, {
              key: id,
              id: id,
              panel: true
            });
      })
    )
  );

const composeWithDevTools = (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose; // @ts-ignore
const configureStore = preloadedState => {
  // compose enhancers with dev tools
  const enhancer = composeWithDevTools(applyMiddleware(thunk$1));
  return createStore(
    (store, action) =>
      produce(store, draft => {
        const reducer = reducers[action.type];
        reducer && reducer(draft, action);
      }),
    preloadedState,
    enhancer
  );
};

const dummyFn = () => null;

class Form extends Component {
  constructor(props) {
    super(props);
    externals.jquery.set(props.jquery);
    if (!props.store) throw new Error('BBDS Form needs an initial datamodel.');
    this.state = {
      store: configureStore(Form.getEnhancedStoreFromProps(props)),
      cache: JSON.stringify(props.store)
    };
  }

  static getEnhancedStoreFromProps(props) {
    const store = JSON.parse(JSON.stringify(props.store));
    store.tmp = {
      debounce: {},
      derive: [],
      autocomplete: [],
      notify: [],
      validate: []
    };
    store.opts = {
      destructiveClear: !!props.destructiveClear,
      // Auto-expand arrays if empty
      autoExpandListIfEmpty: !!props.autoExpandListIfEmpty,
      showListAndMapLabels: !!props.showListAndMapLabels,
      autoExpandRecordIfEmpty: !!props.autoExpandRecordIfEmpty,
      // Style the form
      styles: (function() {
        const styles = JSON.parse(JSON.stringify(DEFAULT_STYLES));
        /* istanbul ignore else */

        if (props.styles)
          for (const [key, value] of Object.entries(props.styles)) {
            /* istanbul ignore else */
            if (value) Object.assign(styles[key], value);
          }
        return styles;
      })(),
      // Autocomplete
      autocomplete: _objectSpread2(
        {
          maxResults: 14,
          debounce: 500
        },
        props.autocomplete
      ),
      // Derive
      derive: _objectSpread2(
        {
          debounce: 150
        },
        props.derive
      ),
      // Notify
      notify: _objectSpread2(
        {
          debounce: 150
        },
        props.notify
      ),
      // Validate
      validate: _objectSpread2(
        {
          debounce: 500
        },
        props.validate
      ),
      // Panels
      seed: props.panels.map(({ key }) => key),
      // External callbacks
      callbacks: {
        onValidate: props.onValidate || dummyFn,
        onDerive: props.onDerive || dummyFn,
        onAutocomplete: props.onAutocomplete || dummyFn,
        onNotify: props.onNotify || dummyFn,
        onError: props.onError || dummyFn,
        labelGet: props.labelGet || dummyFn,
        actionGet: props.actionGet || dummyFn,
        cacheSet: props.cacheSet || dummyFn,
        cacheGet: props.cacheGet || dummyFn,
        uniqueId:
          props.uniqueId ||
          (function() {
            const UID = () => ++UID._;

            UID._ = 0;
            return UID;
          })()
      }
    };
    return store;
  }

  static get defaultProps() {
    return {
      panels: [
        {
          key: 'data',
          expand: true
        }
      ]
    };
  }

  static getDerivedStateFromProps(props, state) {
    const cache = JSON.stringify(props.store);
    if (cache === state.cache) return null;
    return {
      store: configureStore(Form.getEnhancedStoreFromProps(props)),
      cache
    };
  }

  expand() {
    this.state.store.dispatch(expandCollapsible());
  }

  export(notify = true) {
    notify && this.state.store.dispatch(syncTouchAll());
    const store = this.state.store.getState();
    return new Exporter({
      fields: Object.keys(store.data),
      simple: false
    }).transform(store);
  }

  save() {
    const clone = JSON.parse(JSON.stringify(this.state.store.getState()));
    delete clone.valid;
    delete clone.opts;
    delete clone.tmp;
    return clone;
  }

  lock(state) {
    this.state.store.dispatch(toggleLock(state));
  }

  unmount() {
    return Boolean(this.props.anchor) && unmountComponentAtNode(this.props.anchor);
  }

  render() {
    return createElement(App, {
      store: this.state.store,
      panels: this.props.panels
    });
  }
}

const makeLabelCustomizer = labels => {
  const convertedLabels = labels.reduce((acc, { key, value }) => {
    acc[new KeyChain(key).join(true)] = value;
    return acc;
  }, {});
  return chain => convertedLabels[chain.join(true)];
};
const init$2 = (props, anchor) => {
  const formRef = createRef();
  render(
    createElement(
      Form,
      _extends(
        {
          ref: formRef,
          anchor: anchor
        },
        props
      )
    ),
    anchor
  );
  return formRef;
};

///<amd-module name="@dtwebservices/react-bbds-form"/>
const SchemaObjectBuilder = {
  init(records, datasetName, flatExtensionRecords) {
    return new Builder(
      new Avro(records, {
        root: datasetName
      }),
      {
        extensions: flatExtensionRecords
      }
    );
  }
};

export {
  Avro,
  Form as BbdsForm,
  Builder,
  Store as Datamodel,
  Deriver,
  Exporter,
  Grapher,
  KeyChain,
  Merger,
  Mutator,
  KeyChain as SchemaFormKeychain,
  SchemaObjectBuilder,
  Validator,
  index as adapters,
  index$2 as datamodel,
  init$2 as init,
  makeLabelCustomizer,
  uid$1 as makeSimpleServerUID,
  index$3 as mutators,
  index$1 as transformers
};
